function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
/**
 * Fresco - A Beautiful Responsive Lightbox - v2.3.2
 * (c) 2012-2021 Nick Stakenburg
 *
 * https://github.com/staaky/fresco
 *
 * @license: https://creativecommons.org/licenses/by/4.0
 */
!function (i, e) {
  "function" == typeof define && define.amd ? define(["jquery"], e) : "object" == (typeof module === "undefined" ? "undefined" : _typeof(module)) && module.exports ? module.exports = e(require("jquery")) : i.Fresco = e(jQuery);
}(this, function ($) {
  var Fresco = {};
  $.extend(Fresco, {
    version: "2.3.2"
  }), Fresco.Skins = {
    fresco: {}
  };
  var Bounds = {
      viewport: function viewport() {
        var i,
          e = {
            width: $(window).width()
          };
        return Browser.MobileSafari || Browser.Android && Browser.Gecko ? (i = document.documentElement.clientWidth / window.innerWidth, e.height = window.innerHeight * i) : e.height = $(window).height(), e;
      }
    },
    Browser = (e = navigator.userAgent, {
      IE: !(!window.attachEvent || -1 !== e.indexOf("Opera")) && f("MSIE "),
      Opera: -1 < e.indexOf("Opera") && (!!window.opera && opera.version && parseFloat(opera.version()) || 7.55),
      WebKit: -1 < e.indexOf("AppleWebKit/") && f("AppleWebKit/"),
      Gecko: -1 < e.indexOf("Gecko") && -1 === e.indexOf("KHTML") && f("rv:"),
      MobileSafari: !!e.match(/Apple.*Mobile.*Safari/),
      Chrome: -1 < e.indexOf("Chrome") && f("Chrome/"),
      ChromeMobile: -1 < e.indexOf("CrMo") && f("CrMo/"),
      Android: -1 < e.indexOf("Android") && f("Android "),
      IEMobile: -1 < e.indexOf("IEMobile") && f("IEMobile/")
    }),
    e;
  function f(i) {
    i = new RegExp(i + "([\\d.]+)").exec(e);
    return !i || parseFloat(i[1]);
  }
  var _slice = Array.prototype.slice;
  function baseToString(i) {
    return "string" == typeof i ? i : null == i ? "" : i + "";
  }
  var _ = {
    isElement: function isElement(i) {
      return i && 1 === i.nodeType;
    },
    String: {
      capitalize: function capitalize(i) {
        return (i = baseToString(i)) && i.charAt(0).toUpperCase() + i.slice(1);
      }
    }
  };
  $(document.documentElement).on("mousewheel DOMMouseScroll", function (i) {
    var e, t;
    i.originalEvent.wheelDelta ? e = i.originalEvent.wheelDelta / 120 : i.originalEvent.detail && (e = -i.originalEvent.detail / 3), e && (t = $.Event("fresco:mousewheel"), $(i.target).trigger(t, e), t.isPropagationStopped() && i.stopPropagation(), t.isDefaultPrevented() && i.preventDefault());
  });
  var Fit = {
    within: function within(i, e) {
      for (var t, s = $.extend({
          height: !0,
          width: !0
        }, arguments[2] || {}), n = $.extend({}, e), o = 5, a = s.width, h = s.height; 0 < o && (a && n.width > i.width || h && n.height > i.height);) {
        var r = 1,
          d = 1;
        a && n.width > i.width && (r = i.width / n.width), h && n.height > i.height && (d = i.height / n.height), t = Math.min(r, d), n = {
          width: e.width * t,
          height: e.height * t
        }, o--;
      }
      return n.width = Math.max(n.width, 0), n.height = Math.max(n.height, 0), n;
    }
  };
  $.extend($.easing, {
    frescoEaseInCubic: function frescoEaseInCubic(i, e, t, s, n) {
      return s * (e /= n) * e * e + t;
    },
    frescoEaseInSine: function frescoEaseInSine(i, e, t, s, n) {
      return -s * Math.cos(e / n * (Math.PI / 2)) + s + t;
    },
    frescoEaseOutSine: function frescoEaseOutSine(i, e, t, s, n) {
      return s * Math.sin(e / n * (Math.PI / 2)) + t;
    }
  });
  var Support = (O = document.createElement("div"), P = "Webkit Moz O ms Khtml".split(" "), {
      canvas: !(!(ba = document.createElement("canvas")).getContext || !ba.getContext("2d")),
      css: {
        animation: S("animation"),
        transform: S("transform"),
        prefixed: function prefixed(i) {
          return S(i, "prefix");
        }
      },
      svg: !!document.createElementNS && !!document.createElementNS("http://www.w3.org/2000/svg", "svg").createSVGRect,
      touch: function () {
        try {
          return !!("ontouchstart" in window || window.DocumentTouch && document instanceof DocumentTouch);
        } catch (i) {
          return !1;
        }
      }()
    }),
    ba,
    O,
    P;
  function S(i, e) {
    var t = i.charAt(0).toUpperCase() + i.substr(1);
    return function (i, e) {
      for (var t in i) if (void 0 !== O.style[i[t]]) return "prefix" !== e || i[t];
      return !1;
    }((i + " " + P.join(t + " ") + t).split(" "), e);
  }
  Support.detectMobileTouch = function () {
    Support.mobileTouch = Support.touch && (Browser.MobileSafari || Browser.Android || Browser.IEMobile || Browser.ChromeMobile || !/^(Win|Mac|Linux)/.test(navigator.platform));
  }, Support.detectMobileTouch();
  var ImageReady = function ImageReady() {
    return this.initialize.apply(this, Array.prototype.slice.call(arguments));
  };
  function Timers() {
    return this.initialize.apply(this, _slice.call(arguments));
  }
  function getURIData(t) {
    var s = {
      type: "image"
    };
    return $.each(Types, function (i, e) {
      e = e.data(t);
      e && ((s = e).type = i, s.url = t);
    }), s;
  }
  function detectExtension(i) {
    i = (i || "").replace(/\?.*/g, "").match(/\.([^.]{3,4})$/);
    return i ? i[1].toLowerCase() : null;
  }
  $.extend(ImageReady.prototype, {
    supports: {
      naturalWidth: "naturalWidth" in new Image()
    },
    initialize: function initialize(i, e, t) {
      this.img = $(i)[0], this.successCallback = e, this.errorCallback = t, this.isLoaded = !1, this.options = $.extend({
        method: "naturalWidth",
        pollFallbackAfter: 1e3
      }, arguments[3] || {}), this.supports.naturalWidth && "onload" !== this.options.method ? this.img.complete && void 0 !== this.img.naturalWidth ? setTimeout(function () {
        0 < this.img.naturalWidth ? this.success() : this.error();
      }.bind(this)) : ($(this.img).bind("error", function () {
        setTimeout(function () {
          this.error();
        }.bind(this));
      }.bind(this)), this.intervals = [[1e3, 10], [2e3, 50], [4e3, 100], [2e4, 500]], this._ipos = 0, this._time = 0, this._delay = this.intervals[this._ipos][1], this.poll()) : setTimeout(this.fallback.bind(this));
    },
    poll: function poll() {
      this._polling = setTimeout(function () {
        if (0 < this.img.naturalWidth) this.success();else {
          if (this._time += this._delay, this.options.pollFallbackAfter && this._time >= this.options.pollFallbackAfter && !this._usedPollFallback && (this._usedPollFallback = !0, this.fallback()), this._time > this.intervals[this._ipos][0]) {
            if (!this.intervals[this._ipos + 1]) return void this.error();
            this._ipos++, this._delay = this.intervals[this._ipos][1];
          }
          this.poll();
        }
      }.bind(this), this._delay);
    },
    fallback: function fallback() {
      var i = new Image();
      (this._fallbackImg = i).onload = function () {
        i.onload = function () {}, this.supports.naturalWidth || (this.img.naturalWidth = i.width, this.img.naturalHeight = i.height), this.success();
      }.bind(this), i.onerror = this.error.bind(this), i.src = this.img.src;
    },
    abort: function abort() {
      this._fallbackImg && (this._fallbackImg.onload = function () {}), this._polling && (clearTimeout(this._polling), this._polling = null);
    },
    success: function success() {
      this._calledSuccess || (this._calledSuccess = !0, this.isLoaded = !0, this.successCallback(this));
    },
    error: function error() {
      this._calledError || (this._calledError = !0, this.abort(), this.errorCallback && this.errorCallback(this));
    }
  }), $.extend(Timers.prototype, {
    initialize: function initialize() {
      this._timers = {};
    },
    set: function set(i, e, t) {
      this._timers[i] = setTimeout(e, t);
    },
    get: function get(i) {
      return this._timers[i];
    },
    clear: function clear(i) {
      i ? this._timers[i] && (clearTimeout(this._timers[i]), delete this._timers[i]) : this.clearAll();
    },
    clearAll: function clearAll() {
      $.each(this._timers, function (i, e) {
        clearTimeout(e);
      }), this._timers = {};
    }
  });
  var Type = {
      isVideo: function isVideo(i) {
        return /^(youtube|vimeo)$/.test(i);
      }
    },
    Types = {
      image: {
        extensions: "bmp gif jpeg jpg png webp",
        detect: function detect(i) {
          return -1 < $.inArray(detectExtension(i), this.extensions.split(" "));
        },
        data: function data(i) {
          return !!this.detect() && {
            extension: detectExtension(i)
          };
        }
      },
      vimeo: {
        detect: function detect(i) {
          i = /(vimeo\.com)\/([a-zA-Z0-9-_]+)(?:\S+)?$/i.exec(i);
          return !(!i || !i[2]) && i[2];
        },
        data: function data(i) {
          i = this.detect(i);
          return !!i && {
            id: i
          };
        }
      },
      youtube: {
        detect: function detect(i) {
          var e = /(youtube\.com|youtu\.be)\/watch\?(?=.*vi?=([a-zA-Z0-9-_]+))(?:\S+)?$/.exec(i);
          return e && e[2] ? e[2] : !(!(e = /(youtube\.com|youtu\.be)\/(vi?\/|u\/|embed\/)?([a-zA-Z0-9-_]+)(?:\S+)?$/i.exec(i)) || !e[3]) && e[3];
        },
        data: function data(i) {
          i = this.detect(i);
          return !!i && {
            id: i
          };
        }
      }
    },
    VimeoThumbnail = function () {
      function i() {
        return this.initialize.apply(this, _slice.call(arguments));
      }
      $.extend(i.prototype, {
        initialize: function initialize(i, e, t) {
          this.url = i, this.successCallback = e, this.errorCallback = t, this.load();
        },
        load: function load() {
          var i = t.get(this.url);
          if (i) return this.successCallback(i.data.url);
          var e = "http" + (window.location && "https:" === window.location.protocol ? "s" : "") + ":",
            i = getURIData(this.url).id;
          this._xhr = $.getJSON(e + "//vimeo.com/api/oembed.json?url=" + e + "//vimeo.com/" + i + "&callback=?", function (i) {
            i && i.thumbnail_url ? (i = {
              url: i.thumbnail_url
            }, t.set(this.url, i), this.successCallback(i.url)) : this.errorCallback();
          }.bind(this));
        },
        abort: function abort() {
          this._xhr && (this._xhr.abort(), this._xhr = null);
        }
      });
      var t = {
        cache: [],
        get: function get(i) {
          for (var e = null, t = 0; t < this.cache.length; t++) this.cache[t] && this.cache[t].url === i && (e = this.cache[t]);
          return e;
        },
        set: function set(i, e) {
          this.remove(i), this.cache.push({
            url: i,
            data: e
          });
        },
        remove: function remove(i) {
          for (var e = 0; e < this.cache.length; e++) this.cache[e] && this.cache[e].url === i && delete this.cache[e];
        }
      };
      return i;
    }(),
    VimeoReady = function () {
      function i() {
        return this.initialize.apply(this, _slice.call(arguments));
      }
      $.extend(i.prototype, {
        initialize: function initialize(i, e) {
          this.url = i, this.callback = e, this.load();
        },
        load: function load() {
          var i = t.get(this.url);
          if (i) return this.callback(i.data);
          var e = "http" + (window.location && "https:" === window.location.protocol ? "s" : "") + ":",
            i = getURIData(this.url).id;
          this._xhr = $.getJSON(e + "//vimeo.com/api/oembed.json?url=" + e + "//vimeo.com/" + i + "&maxwidth=9999999&maxheight=9999999&callback=?", function (i) {
            i = {
              dimensions: {
                width: i.width,
                height: i.height
              }
            };
            t.set(this.url, i), this.callback && this.callback(i);
          }.bind(this));
        },
        abort: function abort() {
          this._xhr && (this._xhr.abort(), this._xhr = null);
        }
      });
      var t = {
        cache: [],
        get: function get(i) {
          for (var e = null, t = 0; t < this.cache.length; t++) this.cache[t] && this.cache[t].url === i && (e = this.cache[t]);
          return e;
        },
        set: function set(i, e) {
          this.remove(i), this.cache.push({
            url: i,
            data: e
          });
        },
        remove: function remove(i) {
          for (var e = 0; e < this.cache.length; e++) this.cache[e] && this.cache[e].url === i && delete this.cache[e];
        }
      };
      return i;
    }(),
    Options = {
      defaults: {
        effects: {
          content: {
            show: 150,
            hide: 150
          },
          spinner: {
            show: 150,
            hide: 150
          },
          window: {
            show: 440,
            hide: 300
          },
          thumbnail: {
            show: 300,
            delay: 150
          },
          thumbnails: {
            slide: 0
          }
        },
        keyboard: {
          left: !0,
          right: !0,
          esc: !0
        },
        loadedMethod: "naturalWidth",
        loop: !1,
        onClick: "previous-next",
        overflow: !1,
        overlay: {
          close: !0
        },
        preload: [1, 2],
        position: !0,
        skin: "fresco",
        spinner: !0,
        spinnerDelay: 300,
        sync: !0,
        thumbnails: "horizontal",
        ui: "outside",
        uiDelay: 3e3,
        vimeo: {
          autoplay: 1,
          api: 1,
          title: 1,
          byline: 1,
          portrait: 0,
          loop: 0
        },
        youtube: {
          autoplay: 1,
          controls: 1,
          enablejsapi: 1,
          hd: 1,
          iv_load_policy: 3,
          loop: 0,
          modestbranding: 1,
          rel: 0,
          vq: "hd1080"
        },
        initialTypeOptions: {
          image: {},
          vimeo: {
            width: 1280
          },
          youtube: {
            width: 1280,
            height: 720
          }
        }
      },
      create: function create(i, e, t) {
        t = t || {}, (i = i || {}).skin = i.skin || this.defaults.skin;
        var s = i.skin ? $.extend({}, Fresco.Skins[i.skin] || Fresco.Skins[this.defaults.skin]) : {},
          s = $.extend(!0, {}, this.defaults, s);
        s.initialTypeOptions && delete (s = e && s.initialTypeOptions[e] ? $.extend(!0, {}, s.initialTypeOptions[e], s) : s).initialTypeOptions;
        var n = $.extend(!0, {}, s, i);
        if (Support.mobileTouch && "inside" === n.ui && (n.ui = "outside"), (!n.effects || Browser.IE && Browser.IE < 9) && (n.effects = {}, $.each(this.defaults.effects, function (e, i) {
          $.each(n.effects[e] = $.extend({}, i), function (i) {
            n.effects[e][i] = 0;
          });
        }), n.spinner = !1), n.keyboard && ("boolean" == typeof n.keyboard && (n.keyboard = {}, $.each(this.defaults.keyboard, function (i, e) {
          n.keyboard[i] = !0;
        })), "vimeo" !== e && "youtube" !== e || $.extend(n.keyboard, {
          left: !1,
          right: !1
        })), !n.overflow || Support.mobileTouch ? n.overflow = {
          x: !1,
          y: !1
        } : "boolean" == typeof n.overflow && (n.overflow = {
          x: !1,
          y: !0
        }), "vimeo" !== e && "youtube" !== e || (n.overlap = !1), (Browser.IE && Browser.IE < 9 || Support.mobileTouch) && (n.thumbnail = !1, n.thumbnails = !1), "youtube" !== e && (n.width && !n.maxWidth && (n.maxWidth = n.width), n.height && !n.maxHeight && (n.maxHeight = n.height)), !n.thumbnail && "boolean" != typeof n.thumbnail) {
          var o = !1;
          switch (e) {
            case "youtube":
              o = "http" + (window.location && "https:" === window.location.protocol ? "s" : "") + ":" + "//img.youtube.com/vi/" + t.id + "/0.jpg";
              break;
            case "image":
            case "vimeo":
              o = !0;
          }
          n.thumbnail = o;
        }
        return n;
      }
    },
    Overlay = {
      initialize: function initialize() {
        this.build(), this.visible = !1;
      },
      build: function build() {
        this.element = $('<div class="fr-overlay">').hide().append($('<div class="fr-overlay-background">')), this.element.on("click", function () {
          var i = Pages.page;
          i && i.view && i.view.options.overlay && !i.view.options.overlay.close || Window.hide();
        }.bind(this)), Support.mobileTouch && this.element.addClass("fr-mobile-touch"), this.element.on("fresco:mousewheel", function (i) {
          i.preventDefault();
        });
      },
      setSkin: function setSkin(i) {
        this.skin && this.element.removeClass("fr-overlay-skin-" + this.skin), this.element.addClass("fr-overlay-skin-" + i), this.skin = i;
      },
      attach: function attach() {
        $(document.body).append(this.element);
      },
      detach: function detach() {
        this.element.detach();
      },
      show: function show(i, e) {
        var t;
        this.visible ? i && i() : (this.visible = !0, this.attach(), this.max(), t = Pages.page && Pages.page.view.options.effects.window.show || 0, t = ("number" == typeof e ? e : t) || 0, this.element.stop(!0).fadeTo(t, 1, i));
      },
      hide: function hide(i, e) {
        var t;
        this.visible ? (t = Pages.page && Pages.page.view.options.effects.window.hide || 0, t = ("number" == typeof e ? e : t) || 0, this.element.stop(!0).fadeOut(t || 0, function () {
          this.detach(), this.visible = !1, i && i();
        }.bind(this))) : i && i();
      },
      getScrollDimensions: function getScrollDimensions() {
        var n = {};
        return $.each(["width", "height"], function (i, e) {
          var t = e.substr(0, 1).toUpperCase() + e.substr(1),
            s = document.documentElement;
          n[e] = (Browser.IE ? Math.max(s["offset" + t], s["scroll" + t]) : (Browser.WebKit ? document.body : s)["scroll" + t]) || 0;
        }), n;
      },
      max: function max() {
        var i, e;
        Browser.MobileSafari && Browser.WebKit && Browser.WebKit < 533.18 && (i = this.getScrollDimensions(), this.element.css(i)), Browser.IE && Browser.IE < 9 && (e = Bounds.viewport(), this.element.css({
          height: e.height,
          width: e.width
        })), Support.mobileTouch && !i && this.element.css({
          height: this.getScrollDimensions().height
        });
      }
    },
    Window = {
      initialize: function initialize() {
        this.queues = [];
        this.queues.hide = $({});
        this.pages = [];
        this._tracking = [];
        this._first = true;
        this.timers = new Timers();
        this.build();
        this.setSkin(Options.defaults.skin);
      },
      build: function build() {
        // window
        this.element = $('<div class="fr-window fr-measured">').hide() // start hidden
        .append(this._box = $('<div class="fr-box">').append(this._pages = $('<div class="fr-pages">'))).append(this._thumbnails = $('<div class="fr-thumbnails">'));
        Overlay.initialize();
        Pages.initialize(this._pages);
        Thumbnails.initialize(this._thumbnails);
        Spinner.initialize();
        UI.initialize();

        // support classes
        this.element.addClass("fr" + (!Support.mobileTouch ? "-no" : "") + "-mobile-touch");
        this.element.addClass("fr" + (!Support.svg ? "-no" : "") + "-svg");
        if (Browser.IE) {
          for (var i = 7; i <= 9; i++) {
            if (Browser.IE < i) {
              this.element.addClass("fr-ltIE" + i);
            }
          }
        }

        // prevent mousewheel scroll
        this.element.on("fresco:mousewheel", function (event) {
          event.preventDefault();
        });
      },
      attach: function attach() {
        this._attached || ($(document.body).append(this.element), this._attached = !0);
      },
      detach: function detach() {
        this._attached && (this.element.detach(), this._attached = !1);
      },
      setSkin: function setSkin(i) {
        this._skin && this.element.removeClass("fr-window-skin-" + this._skin), this.element.addClass("fr-window-skin-" + i), Overlay.setSkin(i), this._skin = i;
      },
      setShowingType: function setShowingType(i) {
        this._showingType !== i && (this._showingType && (this.element.removeClass("fr-showing-type-" + this._showingType), Type.isVideo(this._showingType) && this.element.removeClass("fr-showing-type-video")), this.element.addClass("fr-showing-type-" + i), Type.isVideo(i) && this.element.addClass("fr-showing-type-video"), this._showingType = i);
      },
      startObservingResize: function startObservingResize() {
        this._onWindowResizeHandler || $(window).on("resize orientationchange", this._onWindowResizeHandler = this._onWindowResize.bind(this));
      },
      stopObservingResize: function stopObservingResize() {
        this._onWindowResizeHandler && ($(window).off("resize orientationchange", this._onWindowResizeHandler), this._onWindowResizeHandler = null);
      },
      _onScroll: function _onScroll() {
        Support.mobileTouch && this.timers.set("scroll", this.adjustToScroll.bind(this), 0);
      },
      _onWindowResize: function _onWindowResize() {
        var i;
        (i = Pages.page) && (Thumbnails.fitToViewport(), this.updateBoxDimensions(), i.fitToBox(), UI.update(), UI.adjustPrevNext(null, 0), Spinner.center(), Overlay.max(), UI._onWindowResize(), this._onScroll());
      },
      adjustToScroll: function adjustToScroll() {
        Support.mobileTouch && this.element.css({
          top: $(window).scrollTop()
        });
      },
      getBoxDimensions: function getBoxDimensions() {
        return this._boxDimensions;
      },
      updateBoxDimensions: function updateBoxDimensions() {
        var i, e, t;
        Pages.page && (i = Bounds.viewport(), e = Thumbnails.getDimensions(), t = "horizontal" === Thumbnails._orientation, this._boxDimensions = {
          width: t ? i.width : i.width - e.width,
          height: t ? i.height - e.height : i.height
        }, this._boxPosition = {
          top: 0,
          left: t ? 0 : e.width
        }, this._box.css($.extend({}, this._boxDimensions, this._boxPosition)));
      },
      show: function show(i, e) {
        var t, s;
        this.visible ? i && i() : (this.visible = !0, this.opening = !0, this.attach(), this.timers.clear("show-window"), this.timers.clear("hide-overlay"), this.adjustToScroll(), t = ("number" == typeof e ? e : Pages.page && Pages.page.view.options.effects.window.show) || 0, s = 2, Overlay[Pages.page && Pages.page.view.options.overlay ? "show" : "hide"](function () {
          i && --s < 1 && i();
        }, t), this.timers.set("show-window", function () {
          this._show(function () {
            this.opening = !1, i && --s < 1 && i();
          }.bind(this), t);
        }.bind(this), 1 < t ? Math.min(0.5 * t, 50) : 1));
      },
      _show: function _show(i, e) {
        e = ("number" == typeof e ? e : Pages.page && Pages.page.view.options.effects.window.show) || 0;
        this.element.stop(!0).fadeTo(e, 1, i);
      },
      hide: function hide(e) {
        var i, t;
        this.view && ((i = this.queues.hide).queue([]), this.timers.clear("show-window"), this.timers.clear("hide-overlay"), t = Pages.page ? Pages.page.view.options.effects.window.hide : 0, i.queue(function (i) {
          Pages.stop(), Spinner.hide(), i();
        }.bind(this)), i.queue(function (i) {
          UI.disable(), UI.hide(null, t), Keyboard.disable(), i();
        }.bind(this)), i.queue(function (i) {
          var e = 2;
          this._hide(function () {
            --e < 1 && i();
          }, t), this.timers.set("hide-overlay", function () {
            Overlay.hide(function () {
              --e < 1 && i();
            }, t);
          }.bind(this), 1 < t ? Math.min(0.5 * t, 150) : 1), this._first = !0;
        }.bind(this)), i.queue(function (i) {
          this._reset(), this.stopObservingResize(), Pages.removeAll(), Thumbnails.clear(), this.timers.clear(), this._position = -1;
          var e = Pages.page && Pages.page.view.options.afterHide;
          "function" == typeof e && e.call(Fresco), this.view = null, this.opening = !1, this.closing = !1, this.detach(), i();
        }.bind(this)), "function" == typeof e && i.queue(function (i) {
          e(), i();
        }.bind(this)));
      },
      _hide: function _hide(i, e) {
        e = ("number" == typeof e ? e : Pages.page && Pages.page.view.options.effects.window.hide) || 0;
        this.element.stop(!0).fadeOut(e, i);
      },
      load: function load(i, e) {
        this.views = i, this.attach(), Thumbnails.load(i), Pages.load(i), this.startObservingResize(), e && this.setPosition(e);
      },
      setPosition: function setPosition(i, e) {
        this._position = i, this.view = this.views[i - 1], this.stopHideQueue(), this.page = Pages.show(i, function () {
          e && e();
        }.bind(this));
      },
      stopHideQueue: function stopHideQueue() {
        this.queues.hide.queue([]);
      },
      _reset: function _reset() {
        this.visible = !1, UI.hide(null, 0), UI.reset();
      },
      mayPrevious: function mayPrevious() {
        return this.view && this.view.options.loop && this.views && 1 < this.views.length || 1 !== this._position;
      },
      previous: function previous(i) {
        var e = this.mayPrevious();
        (i || e) && this.setPosition(this.getSurroundingIndexes().previous);
      },
      mayNext: function mayNext() {
        var i = this.views && 1 < this.views.length;
        return this.view && this.view.options.loop && i || i && 1 !== this.getSurroundingIndexes().next;
      },
      next: function next(i) {
        var e = this.mayNext();
        (i || e) && this.setPosition(this.getSurroundingIndexes().next);
      },
      getSurroundingIndexes: function getSurroundingIndexes() {
        if (!this.views) return {};
        var i = this._position,
          e = this.views.length;
        return {
          previous: i <= 1 ? e : i - 1,
          next: e <= i ? 1 : i + 1
        };
      }
    },
    Keyboard = {
      enabled: !1,
      keyCode: {
        left: 37,
        right: 39,
        esc: 27
      },
      enable: function enable(i) {
        this.disable(), i && ($(document).on("keydown", this._onKeyDownHandler = this.onKeyDown.bind(this)).on("keyup", this._onKeyUpHandler = this.onKeyUp.bind(this)), this.enabled = i);
      },
      disable: function disable() {
        this.enabled = !1, this._onKeyUpHandler && ($(document).off("keyup", this._onKeyUpHandler).off("keydown", this._onKeyDownHandler), this._onKeyUpHandler = this._onKeyDownHandler = null);
      },
      onKeyDown: function onKeyDown(i) {
        if (this.enabled) {
          var e = this.getKeyByKeyCode(i.keyCode);
          if (e && (!this.enabled || this.enabled[e])) switch (i.preventDefault(), i.stopPropagation(), e) {
            case "left":
              Window.previous();
              break;
            case "right":
              Window.next();
          }
        }
      },
      onKeyUp: function onKeyUp(i) {
        this.enabled && (!(i = this.getKeyByKeyCode(i.keyCode)) || this.enabled && !this.enabled[i] || "esc" === i && Window.hide());
      },
      getKeyByKeyCode: function getKeyByKeyCode(i) {
        for (var e in this.keyCode) if (this.keyCode[e] === i) return e;
        return null;
      }
    },
    Page = (Lb = 0, Mb = {}, Nb = $("<div>").addClass("fr-stroke fr-stroke-top fr-stroke-horizontal").append($("<div>").addClass("fr-stroke-color")).add($("<div>").addClass("fr-stroke fr-stroke-bottom fr-stroke-horizontal").append($("<div>").addClass("fr-stroke-color"))).add($("<div>").addClass("fr-stroke fr-stroke-left fr-stroke-vertical").append($("<div>").addClass("fr-stroke-color"))).add($("<div>").addClass("fr-stroke fr-stroke-right fr-stroke-vertical").append($("<div>").addClass("fr-stroke-color"))), $.extend(Ob.prototype, {
      initialize: function initialize(i, e, t) {
        this.view = i, this.dimensions = {
          width: 0,
          height: 0
        }, this.uid = Lb++, this._position = e, this._total = t, this._fullClick = !1, this._visible = !1, this.queues = {}, this.queues.showhide = $({});
      },
      create: function create() {
        var i, e;
        this._created || (Pages.element.append(this.element = $("<div>").addClass("fr-page").append(this.container = $("<div>").addClass("fr-container")).css({
          opacity: 0
        }).hide()), (e = this.view.options.position && 1 < this._total) && this.element.addClass("fr-has-position"), (this.view.caption || e) && (this.element.append(this.info = $("<div>").addClass("fr-info").append($("<div>").addClass("fr-info-background")).append(Nb.clone(!0)).append(this.infoPadder = $("<div>").addClass("fr-info-padder"))), e && (this.element.addClass("fr-has-position"), this.infoPadder.append(this.pos = $("<div>").addClass("fr-position").append($("<span>").addClass("fr-position-text").html(this._position + " / " + this._total)))), this.view.caption && this.infoPadder.append(this.caption = $("<div>").addClass("fr-caption").html(this.view.caption))), this.container.append(this.background = $("<div>").addClass("fr-content-background")).append(this.content = $("<div>").addClass("fr-content")), "image" == this.view.type && (this.content.append(this.image = $("<img>").addClass("fr-content-element").attr({
          src: this.view.url
        })), this.content.append(Nb.clone(!0))), e && "outside" == this.view.options.ui && this.container.append(this.positionOutside = $("<div>").addClass("fr-position-outside").append($("<div>").addClass("fr-position-background")).append($("<span>").addClass("fr-position-text").html(this._position + " / " + this._total))), "inside" == this.view.options.ui && (this.content.append(this.previousInside = $("<div>").addClass("fr-side fr-side-previous fr-toggle-ui").append($("<div>").addClass("fr-side-button").append($("<div>").addClass("fr-side-button-background")).append($("<div>").addClass("fr-side-button-icon")))).append(this.nextInside = $("<div>").addClass("fr-side fr-side-next fr-toggle-ui").append($("<div>").addClass("fr-side-button").append($("<div>").addClass("fr-side-button-background")).append($("<div>").addClass("fr-side-button-icon")))).append(this.closeInside = $("<div>").addClass("fr-close fr-toggle-ui").append($("<div>").addClass("fr-close-background")).append($("<div>").addClass("fr-close-icon"))), (this.view.caption || e && this.view.grouped.caption) && (this.content.append(this.infoInside = $("<div>").addClass("fr-info fr-toggle-ui").append($("<div>").addClass("fr-info-background")).append(Nb.clone(!0)).append(this.infoPadderInside = $("<div>").addClass("fr-info-padder"))), e && this.infoPadderInside.append(this.posInside = $("<div>").addClass("fr-position").append($("<span>").addClass("fr-position-text").html(this._position + " / " + this._total))), this.view.caption && this.infoPadderInside.append(this.captionInside = $("<div>").addClass("fr-caption").html(this.view.caption))), this.view.caption || !e || this.view.grouped.caption || this.content.append(this.positionInside = $("<div>").addClass("fr-position-inside fr-toggle-ui").append($("<div>").addClass("fr-position-background")).append($("<span>").addClass("fr-position-text").html(this._position + " / " + this._total))), i = this.view.options.loop && 1 < this._total || 1 != this._position, e = this.view.options.loop && 1 < this._total || this._position < this._total, this.previousInside[(i ? "remove" : "add") + "Class"]("fr-side-disabled"), this.nextInside[(e ? "remove" : "add") + "Class"]("fr-side-disabled")), $.each(["x", "y"], function (i, e) {
          this.view.options.overflow[e] && this.element.addClass("fr-overflow-" + e);
        }.bind(this)), this.element.addClass("fr-type-" + this.view.type), Type.isVideo(this.view.type) && this.element.addClass("fr-type-video"), this._total < 2 && this.element.addClass("fr-no-sides"), this._created = !0);
      },
      _getSurroundingPages: function _getSurroundingPages() {
        var i;
        if (!(i = this.view.options.preload)) return [];
        for (var e = [], t = Math.max(1, this._position - i[0]), s = Math.min(this._position + i[1], this._total), n = this._position, o = n; o <= s; o++) (a = Pages.pages[o - 1])._position != n && e.push(a);
        for (var a, o = n; t <= o; o--) (a = Pages.pages[o - 1])._position != n && e.push(a);
        return e;
      },
      preloadSurroundingImages: function preloadSurroundingImages() {
        var i = this._getSurroundingPages();
        $.each(i, function (i, e) {
          e.preload();
        }.bind(this));
      },
      preload: function preload() {
        this.preloading || this.preloaded || "image" != this.view.type || !this.view.options.preload || this.loaded || (this.create(), this.preloading = !0, this.preloadReady = new ImageReady(this.image[0], function (i) {
          this.loaded = !0, Mb[this.view.url] = !0, this.preloading = !1, this.preloaded = !0, this.dimensions = {
            width: i.img.naturalWidth,
            height: i.img.naturalHeight
          };
        }.bind(this), null, {
          method: "naturalWidth"
        }));
      },
      load: function load(e, i) {
        if (this.create(), this.loaded) e && e();else switch (this.abort(), this.loading = !0, this.view.options.spinner && (this._spinnerDelay = setTimeout(function () {
          Spinner.show();
        }.bind(this), this.view.options.spinnerDelay || 0)), this.view.type) {
          case "image":
            if (this.error) return void (e && e());
            this.imageReady = new ImageReady(this.image[0], function (i) {
              this._markAsLoaded(), this.setDimensions({
                width: i.img.naturalWidth,
                height: i.img.naturalHeight
              }), e && e();
            }.bind(this), function () {
              this._markAsLoaded(), this.image.hide(), this.content.prepend(this.error = $("<div>").addClass("fr-error fr-content-element").append($("<div>").addClass("fr-error-icon"))), this.element.addClass("fr-has-error"), this.setDimensions({
                width: this.error.outerWidth(),
                height: this.error.outerHeight()
              }), this.error.css({
                width: "100%",
                height: "100%"
              }), e && e();
            }.bind(this), {
              method: this.view.options.loadedMethod
            });
            break;
          case "vimeo":
            this.vimeoReady = new VimeoReady(this.view.url, function (i) {
              this._markAsLoaded(), this.setDimensions({
                width: i.dimensions.width,
                height: i.dimensions.height
              }), e && e();
            }.bind(this));
            break;
          case "youtube":
            this._markAsLoaded(), this.setDimensions({
              width: this.view.options.width,
              height: this.view.options.height
            }), e && e();
        }
      },
      setDimensions: function setDimensions(i) {
        this.dimensions = i, (this.view.options.maxWidth || this.view.options.maxHeight) && (i = {
          width: (i = this.view.options).maxWidth || this.dimensions.width,
          height: i.maxHeight || this.dimensions.height
        }, this.dimensions = Fit.within(i, this.dimensions));
      },
      _markAsLoaded: function _markAsLoaded() {
        this._abortSpinnerDelay(), this.loading = !1, this.loaded = !0, Mb[this.view.url] = !0, Spinner.hide(null, null, this._position);
      },
      isVideo: function isVideo() {
        return Type.isVideo(this.view.type);
      },
      insertVideo: function insertVideo(i) {
        var e, t;
        !this.playerIframe && this.isVideo() && (e = "http" + (window.location && "https:" === window.location.protocol ? "s" : "") + ":", t = $.extend({}, this.view.options[this.view.type] || {}), t = $.param(t), t = {
          vimeo: e + "//player.vimeo.com/video/{id}?{queryString}",
          youtube: e + "//www.youtube.com/embed/{id}?{queryString}"
        }[this.view.type].replace("{id}", this.view._data.id).replace("{queryString}", t), this.content.prepend(this.playerIframe = $("<iframe webkitAllowFullScreen mozallowfullscreen allowFullScreen>").addClass("fr-content-element").attr({
          src: t,
          height: this._contentDimensions.height,
          width: this._contentDimensions.width,
          frameborder: 0
        }))), i && i();
      },
      raise: function raise() {
        var i = Pages.element[0].lastChild;
        i && i === this.element[0] || Pages.element.append(this.element);
      },
      show: function show(e) {
        var i = this.queues.showhide;
        i.queue([]), i.queue(function (i) {
          var e = this.view.options.spinner && !Mb[this.view.url];
          Spinner._visible && !e && Spinner.hide(), Pages.stopInactive(), i();
        }.bind(this)), i.queue(function (i) {
          this.updateUI(), UI.set(this._ui), i();
        }.bind(this)), i.queue(function (i) {
          Keyboard.enable(this.view.options.keyboard), i();
        }.bind(this)), i.queue(function (i) {
          Spinner.setSkin(this.view.options.skin), this.load(function () {
            this.preloadSurroundingImages(), i();
          }.bind(this));
        }.bind(this)), i.queue(function (i) {
          this.raise(), Window.setSkin(this.view.options.skin), UI.enable(), this.fitToBox(), Window.adjustToScroll(), i();
        }.bind(this)), this.isVideo() && i.queue(function (i) {
          this.insertVideo(function () {
            i();
          });
        }.bind(this)), this.view.options.sync || i.queue(function (i) {
          Pages.hideInactive(i);
        }.bind(this)), i.queue(function (i) {
          var e = 3,
            t = this.view.options.effects.content.show;
          Window.setShowingType(this.view.type), Window.visible || (t = this.view.options.effects.window.show, "function" == typeof this.view.options.onShow && this.view.options.onShow.call(Fresco)), this.view.options.sync && (e++, Pages.hideInactive(function () {
            --e < 1 && i();
          })), Window.show(function () {
            --e < 1 && i();
          }, this.view.options.effects.window.show), this._show(function () {
            --e < 1 && i();
          }, t), UI.adjustPrevNext(function () {
            --e < 1 && i();
          }, Window._first ? 0 : t), Window._first ? (UI.show(null, 0), Window._first = !1) : UI.show(null, 0);
          t = this.view.options.afterPosition;
          "function" == typeof t && t.call(Fresco, this._position);
        }.bind(this)), i.queue(function (i) {
          this._visible = !0, e && e(), i();
        }.bind(this));
      },
      _show: function _show(i, e) {
        e = Window.visible ? "number" == typeof e ? e : this.view.options.effects.content.show : 0;
        this.element.stop(!0).show().fadeTo(e || 0, 1, i);
      },
      hide: function hide(i, e) {
        this.element ? (this.removeVideo(), this.abort(), e = "number" == typeof e ? e : this.view.options.effects.content.hide, this.isVideo() && (e = 0), this.element.stop(!0).fadeTo(e, 0, "frescoEaseInCubic", function () {
          this.element.hide(), this._visible = !1, Pages.removeTracking(this._position), i && i();
        }.bind(this))) : i && i();
      },
      stop: function stop() {
        this.queues.showhide.queue([]), this.element && this.element.stop(!0), this.abort();
      },
      removeVideo: function removeVideo() {
        this.playerIframe && (this.playerIframe[0].src = "//about:blank", this.playerIframe.remove(), this.playerIframe = null);
      },
      remove: function remove() {
        this.stop(), this.removeVideo(), this.element && this.element.remove(), this._track && (Pages.removeTracking(this._position), this._track = !1), this.preloadReady && (this.preloadReady.abort(), this.preloadReady = null, this.preloading = null, this.preloaded = null), this._visible = !1, this.removed = !0;
      },
      abort: function abort() {
        this.imageReady && (this.imageReady.abort(), this.imageReady = null), this.vimeoReady && (this.vimeoReady.abort(), this.vimeoReady = null), this._abortSpinnerDelay(), this.loading = !1;
      },
      _abortSpinnerDelay: function _abortSpinnerDelay() {
        this._spinnerDelay && (clearTimeout(this._spinnerDelay), this._spinnerDelay = null);
      },
      _getInfoHeight: function _getInfoHeight(i) {
        var e = this.view.options.position && 1 < this._total;
        switch (this._ui) {
          case "fullclick":
          case "inside":
            if (!this.view.caption && !e) return 0;
            break;
          case "outside":
            if (!this.view.caption) return 0;
        }
        var t = "inside" === this._ui ? this.infoInside : this.info;
        "outside" === this._ui && (i = Math.min(i, Window._boxDimensions.width));
        var s = t[0].style.width;
        return "inside" !== this._ui && "fullclick" !== this._ui || (s = "100%"), t.css({
          width: i + "px"
        }), i = parseFloat(t.outerHeight()), t.css({
          width: s
        }), i;
      },
      _whileVisible: function _whileVisible(i, e) {
        var t = [],
          s = Window.element.add(this.element);
        e && (s = s.add(e)), $.each(s, function (i, e) {
          $(e).is(":visible") || t.push($(e).show());
        });
        e = this.element.hasClass("fr-no-caption");
        this.element.removeClass("fr-no-caption");
        s = this.element.hasClass("fr-has-caption");
        this.element.addClass("fr-has-caption"), Window.element.css({
          visibility: "hidden"
        }), i(), Window.element.css({
          visibility: "visible"
        }), e && this.element.addClass("fr-no-caption"), s || this.element.removeClass("fr-has-caption"), $.each(t, function (i, e) {
          e.hide();
        });
      },
      updateForced: function updateForced() {
        this.create(), this._fullClick = this.view.options.fullClick, this._noOverflow = !1, 0 < parseInt(this.element.css("min-width")) && (this._fullClick = !0), 0 < parseInt(this.element.css("min-height")) && (this._noOverflow = !0);
      },
      updateUI: function updateUI() {
        this.updateForced();
        var i = this._fullClick ? "fullclick" : this.view.options.ui;
        this._ui && this.element.removeClass("fr-ui-" + this._ui), this.element.addClass("fr-ui-" + i), this._ui = i;
      },
      fitToBox: function fitToBox() {
        if (this.content) {
          this.element;
          var t = $.extend({}, Window.getBoxDimensions()),
            i = $.extend({}, this.dimensions),
            e = this.container;
          this.updateUI();
          var s,
            e = {
              left: parseInt(e.css("padding-left")),
              top: parseInt(e.css("padding-top"))
            };
          "outside" === this._ui && this._positionOutside && (s = 0, this._whileVisible(function () {
            this._positionOutside.is(":visible") && (s = this._positionOutside.outerWidth(!0));
          }.bind(this)), s > e.left && (e.left = s)), t.width -= 2 * e.left, t.height -= 2 * e.top;
          var n,
            o = {
              width: !0,
              height: !!this._noOverflow || !this.view.options.overflow.y
            },
            i = Fit.within(t, i, o),
            a = $.extend({}, i),
            h = (this.content, 0),
            i = "inside" === this._ui,
            r = i ? this.infoInside : this.info,
            d = i ? this.captionInside : this.caption,
            l = i ? this.posInside : this.pos,
            u = !!d;
          switch (this._ui) {
            case "outside":
              var c = $.extend({}, a);
              this.caption && (p = this.caption, this._whileVisible(function () {
                for (var i = 0; i < 2;) {
                  h = this._getInfoHeight(a.width);
                  var e = t.height - a.height;
                  e < h && (a = Fit.within({
                    width: a.width,
                    height: Math.max(a.height - (h - e), 0)
                  }, a, o)), i++;
                }
                h = this._getInfoHeight(a.width);
                (!this.view.options.overflow.y && h + a.height > t.height || r && "none" === r.css("display") || h >= 0.5 * a.height) && (u = !1, h = 0, a = c);
              }.bind(this), p)), r && r.css({
                width: a.width + "px"
              }), n = {
                width: a.width,
                height: a.height + h
              };
              break;
            case "inside":
              this.caption && (p = d, this._whileVisible(function () {
                (h = this._getInfoHeight(a.width)) >= 0.45 * a.height && (u = !1, h = 0);
              }.bind(this), p)), n = a;
              break;
            case "fullclick":
              var p = [];
              d && p.push(d), this._whileVisible(function () {
                var i;
                (d || l) && r.css({
                  width: "100%"
                }), h = this._getInfoHeight(Window._boxDimensions.width), d && h > 0.5 * t.height && (u = !1, l ? (i = this.caption.is(":visible"), this.caption.hide(), h = this._getInfoHeight(Window._boxDimensions.width), i && this.caption.show()) : h = 0), a = Fit.within({
                  width: t.width,
                  height: Math.max(0, t.height - h)
                }, a, o), n = a;
              }.bind(this), p), this.content.css({
                "padding-bottom": 0
              });
          }
          d && d[u ? "show" : "hide"](), this.element[(u ? "remove" : "add") + "Class"]("fr-no-caption"), this.element[(u ? "add" : "remove") + "Class"]("fr-has-caption"), this.content.css(a), this.background.css(n), this.playerIframe && this.playerIframe.attr(a), this.overlap = {
            y: n.height + ("fullclick" === this._ui ? h : 0) - Window._boxDimensions.height,
            x: 0
          }, this._track = !this._noOverflow && this.view.options.overflow.y && 0 < this.overlap.y, this._infoHeight = h, this._padding = e, this._contentDimensions = a, this._backgroundDimensions = n, Pages[(this._track ? "set" : "remove") + "Tracking"](this._position), this.position();
        }
      },
      position: function position() {
        if (this.content) {
          var i = this._contentDimensions,
            e = this._backgroundDimensions,
            t = {
              top: 0.5 * Window._boxDimensions.height - 0.5 * e.height,
              left: 0.5 * Window._boxDimensions.width - 0.5 * e.width
            },
            s = {
              top: t.top + i.height,
              left: t.left
            },
            n = 0,
            o = "inside" === this._ui ? this.infoInside : this.info;
          switch (this._ui) {
            case "fullclick":
              t.top = 0.5 * (Window._boxDimensions.height - this._infoHeight) - 0.5 * e.height, s = {
                top: Window._boxDimensions.height - this._infoHeight,
                left: 0,
                bottom: "auto"
              }, n = this._infoHeight;
              break;
            case "inside":
              s = {
                top: "auto",
                left: 0,
                bottom: 0
              };
          }
          if (0 < this.overlap.y) {
            var a = Pages.getXYP();
            switch (t.top = 0 - a.y * this.overlap.y, this._ui) {
              case "outside":
              case "fullclick":
                s.top = Window._boxDimensions.height - this._infoHeight;
                break;
              case "inside":
                var h,
                  r,
                  d,
                  l = t.top + i.height - Window._boxDimensions.height,
                  u = -1 * t.top;
                s.bottom = l, this.closeInside.css({
                  top: u
                }), 1 < this._total && ((d = Window.element.is(":visible")) || Window.element.show(), r = this.previousInside.attr("style"), this.previousInside.removeAttr("style"), h = parseInt(this.previousInside.css("margin-top")), this.previousInside.attr({
                  style: r
                }), d || Window.element.hide(), r = this.previousInside.add(this.nextInside), d = 0.5 * this.overlap.y, r.css({
                  "margin-top": h + (u - d)
                }), this.positionInside && this.positionInside.css({
                  bottom: l
                }));
            }
          } else "inside" === this._ui && this.element.find(".fr-info, .fr-side, .fr-close, .fr-position-inside").removeAttr("style");
          o && o.css(s), this.container.css({
            bottom: n
          }), this.content.css(t), this.background.css(t);
        }
      }
    }), Ob),
    Lb,
    Mb,
    Nb;
  function Ob() {
    return this.initialize.apply(this, _slice.call(arguments));
  }
  var Pages = {
    initialize: function initialize(i) {
      this.element = i, this.pages = [], this.uid = 1, this._tracking = [];
    },
    load: function load(i) {
      this.views = i, this.removeAll(), $.each(i, function (i, e) {
        this.pages.push(new Page(e, i + 1, this.views.length));
      }.bind(this));
    },
    show: function show(i, e) {
      var t = this.pages[i - 1];
      this.page && this.page.uid === t.uid || (this.page = t, Thumbnails.show(i), Window.updateBoxDimensions(), t.show(function () {
        e && e();
      }.bind(this)));
    },
    getPositionInActivePageGroup: function getPositionInActivePageGroup(t) {
      var s = 0;
      return $.each(this.pages, function (i, e) {
        e.view.element && e.view.element === t && (s = i + 1);
      }), s;
    },
    getLoadingCount: function getLoadingCount() {
      var t = 0;
      return $.each(this.pages, function (i, e) {
        e.loading && t++;
      }), t;
    },
    removeAll: function removeAll() {
      $.each(this.pages, function (i, e) {
        e.remove();
      }), this.pages = [];
    },
    hideInactive: function hideInactive(t, s) {
      var n = [];
      $.each(this.pages, function (i, e) {
        e.uid !== this.page.uid && n.push(e);
      }.bind(this));
      var o = 0 + n.length;
      return o < 1 ? t && t() : $.each(n, function (i, e) {
        e.hide(function () {
          t && --o < 1 && t();
        }, s);
      }), n.length;
    },
    stopInactive: function stopInactive() {
      $.each(this.pages, function (i, e) {
        e.uid !== this.page.uid && e.stop();
      }.bind(this));
    },
    stop: function stop() {
      $.each(this.pages, function (i, e) {
        e.stop();
      });
    },
    handleTracking: function handleTracking(i) {
      Browser.IE && Browser.IE < 9 ? (this.setXY({
        x: i.pageX,
        y: i.pageY
      }), this.updatePositions()) : this._tracking_timer = setTimeout(function () {
        this.setXY({
          x: i.pageX,
          y: i.pageY
        }), this.updatePositions();
      }.bind(this), 30);
    },
    clearTrackingTimer: function clearTrackingTimer() {
      this._tracking_timer && (clearTimeout(this._tracking_timer), this._tracking_timer = null);
    },
    startTracking: function startTracking() {
      Support.mobileTouch || this._handleTracking || $(document.documentElement).on("mousemove", this._handleTracking = this.handleTracking.bind(this));
    },
    stopTracking: function stopTracking() {
      !Support.mobileTouch && this._handleTracking && ($(document.documentElement).off("mousemove", this._handleTracking), this._handleTracking = null, this.clearTrackingTimer());
    },
    setTracking: function setTracking(i) {
      this.isTracking(i) || (this._tracking.push(this.pages[i - 1]), 1 === this._tracking.length && this.startTracking());
    },
    clearTracking: function clearTracking() {
      this._tracking = [];
    },
    removeTracking: function removeTracking(e) {
      this._tracking = $.grep(this._tracking, function (i) {
        return i._position !== e;
      }), this._tracking.length < 1 && this.stopTracking();
    },
    isTracking: function isTracking(t) {
      var s = !1;
      return $.each(this._tracking, function (i, e) {
        if (e._position === t) return !(s = !0);
      }), s;
    },
    setXY: function setXY(i) {
      this._xy = i;
    },
    getXYP: function getXYP() {
      var i = Pages.page,
        t = $.extend({}, Window._boxDimensions),
        e = $.extend({}, this._xy);
      e.y -= $(window).scrollTop(), i && ("outside" === i._ui || "fullclick" === i._ui) && 0 < i._infoHeight && (t.height -= i._infoHeight), e.y -= Window._boxPosition.top;
      var s = {
          x: 0,
          y: Math.min(Math.max(e.y / t.height, 0), 1)
        },
        n = {
          x: "width",
          y: "height"
        },
        o = {};
      return $.each("y".split(" "), function (i, e) {
        o[e] = Math.min(Math.max(20 / t[n[e]], 0), 1), s[e] *= 1 + 2 * o[e], s[e] -= o[e], s[e] = Math.min(Math.max(s[e], 0), 1);
      }.bind(this)), this.setXYP(s), this._xyp;
    },
    setXYP: function setXYP(i) {
      this._xyp = i;
    },
    updatePositions: function updatePositions() {
      this._tracking.length < 1 || $.each(this._tracking, function (i, e) {
        e.position();
      });
    }
  };
  function View() {
    this.initialize.apply(this, _slice.call(arguments));
  }
  $.extend(View.prototype, {
    initialize: function initialize(object) {
      var options = arguments[1] || {},
        data = {},
        element;
      return "string" == typeof object ? object = {
        url: object
      } : object && 1 === object.nodeType && (element = $(object), object = {
        element: element[0],
        url: element.attr("href"),
        caption: element.attr("data-fresco-caption"),
        group: element.attr("data-fresco-group"),
        extension: element.attr("data-fresco-extension"),
        type: element.attr("data-fresco-type"),
        options: element.attr("data-fresco-options") && eval("({" + element.attr("data-fresco-options") + "})") || {}
      }), object && (object.extension || (object.extension = detectExtension(object.url)), object.type || (data = getURIData(object.url), object._data = data, object.type = data.type)), object._data || (object._data = getURIData(object.url)), object && object.options ? object.options = $.extend(!0, $.extend({}, options), $.extend({}, object.options)) : object.options = $.extend({}, options), object.options = Options.create(object.options, object.type, object._data), $.extend(this, object), this;
    }
  });
  var Spinner = {
      supported: Support.css.transform && Support.css.animation,
      initialize: function initialize(i) {
        this.element = $("<div>").addClass("fr-spinner").hide();
        for (var e = 1; e <= 12; e++) this.element.append($("<div>").addClass("fr-spin-" + e));
        this.element.on("click", function () {
          Window.hide();
        }.bind(this)), this.element.on("fresco:mousewheel", function (i) {
          i.preventDefault();
        });
      },
      setSkin: function setSkin(i) {
        this.supported && (this._skin && this.element.removeClass("fr-spinner-skin-" + this._skin), this.updateDimensions(), this.element.addClass("fr-spinner-skin-" + i), this._skin = i);
      },
      updateDimensions: function updateDimensions() {
        var i = this._attached;
        i || this.attach(), this._dimensions = {
          width: this.element.outerWidth(),
          height: this.element.outerHeight()
        }, i || this.detach();
      },
      attach: function attach() {
        this._attached || ($(document.body).append(this.element), this._attached = !0);
      },
      detach: function detach() {
        this._attached && (this.element.detach(), this._attached = !1);
      },
      show: function show(i, e) {
        this._visible = !0, this.attach(), this.center();
        var t = Pages.page && Pages.page.view.options.effects.spinner.show || 0,
          t = ("number" == typeof e ? e : t) || 0;
        this.element.stop(!0).fadeTo(t, 1, i);
      },
      hide: function hide(i, e, t) {
        this._visible = !1;
        var s = Pages.page && Pages.page.view.options.effects.spinner.hide || 0,
          s = ("number" == typeof e ? e : s) || 0;
        this.element.stop(!0).fadeOut(s || 0, function () {
          this.detach(), i && i();
        }.bind(this));
      },
      center: function center() {
        var i, e;
        this.supported && (this._dimensions || this.updateDimensions(), i = Pages.page, e = 0, i && "fullclick" === i._ui && i._whileVisible(function () {
          e = i._getInfoHeight(Window._boxDimensions.width);
        }), this.element.css({
          top: Window._boxPosition.top + 0.5 * Window._boxDimensions.height - 0.5 * this._dimensions.height - 0.5 * e,
          left: Window._boxPosition.left + 0.5 * Window._boxDimensions.width - 0.5 * this._dimensions.width
        }));
      }
    },
    _Fresco = {
      _disabled: !1,
      _fallback: !0,
      initialize: function initialize() {
        Window.initialize(), this._disabled || this.startDelegating();
      },
      startDelegating: function startDelegating() {
        this._delegateHandler || $(document.documentElement).on("click", ".fresco[href]", this._delegateHandler = this.delegate.bind(this)).on("click", this._setClickXYHandler = this.setClickXY.bind(this));
      },
      stopDelegating: function stopDelegating() {
        this._delegateHandler && ($(document.documentElement).off("click", ".fresco[href]", this._delegateHandler).off("click", this._setClickXYHandler), this._setClickXYHandler = null, this._delegateHandler = null);
      },
      setClickXY: function setClickXY(i) {
        Pages.setXY({
          x: i.pageX,
          y: i.pageY
        });
      },
      delegate: function delegate(i) {
        var e;
        this._disabled || (i.stopPropagation(), i.preventDefault(), e = i.currentTarget, this.setClickXY(i), _Fresco.show(e));
      },
      show: function show(object) {
        if (this._disabled) this.showFallback.apply(_Fresco, _slice.call(arguments));else {
          var options = arguments[1] || {},
            position = arguments[2];
          arguments[1] && "number" == typeof arguments[1] && (position = arguments[1], options = {});
          var views = [],
            object_type,
            isElement = _.isElement(object);
          switch (object_type = _typeof(object)) {
            case "string":
            case "object":
              var view = new View(object, options),
                _dgo = "data-fresco-group-options",
                groupOptions = {},
                elements;
              view.group ? isElement && (elements = $('.fresco[data-fresco-group="' + $(object).attr("data-fresco-group") + '"]'), elements.filter("[" + _dgo + "]").each(function (i, element) {
                $.extend(groupOptions, eval("({" + ($(element).attr(_dgo) || "") + "})"));
              }), elements.each(function (i, e) {
                position || e !== object || (position = i + 1), views.push(new View(e, $.extend({}, groupOptions, options)));
              })) : (isElement && $(object).is("[" + _dgo + "]") && ($.extend(groupOptions, eval("({" + ($(object).attr(_dgo) || "") + "})")), view = new View(object, $.extend({}, groupOptions, options))), views.push(view));
              break;
            case "array":
              $.each(object, function (i, e) {
                e = new View(e, options);
                views.push(e);
              });
          }
          var groupExtend = {
              grouped: {
                caption: !1
              }
            },
            firstUI = views[0].options.ui,
            positionInAPG;
          $.each(views, function (i, e) {
            e.caption && (groupExtend.grouped.caption = !0), 0 < i && e.options.ui !== firstUI && (e.options.ui = firstUI);
          }), $.each(views, function (i, e) {
            $.extend(e, groupExtend);
          }), (!position || position < 1) && (position = 1), position > views.length && (position = views.length), isElement && (positionInAPG = Pages.getPositionInActivePageGroup(object)) ? Window.setPosition(positionInAPG) : Window.load(views, position);
        }
      },
      showFallback: function showFallback(i) {
        !this._fallback || (i = function i(e) {
          var t = _typeof(e),
            e = "string" == t ? e : "array" == t && e[0] ? i(e[0]) : _.isElement(e) && $(e).attr("href") ? $(e).attr("href") : e.url || !1;
          return e;
        }(i)) && (window.location.href = i);
      }
    };
  $.extend(Fresco, {
    show: function show(i) {
      return _Fresco.show.apply(_Fresco, _slice.call(arguments)), this;
    },
    hide: function hide() {
      return Window.hide(), this;
    },
    disable: function disable() {
      return _Fresco.stopDelegating(), _Fresco._disabled = !0, this;
    },
    enable: function enable() {
      return _Fresco._disabled = !1, _Fresco.startDelegating(), this;
    },
    fallback: function fallback(i) {
      return _Fresco._fallback = i, this;
    },
    setDefaultSkin: function setDefaultSkin(i) {
      return Options.defaults.skin = i, this;
    }
  }), (Browser.IE && Browser.IE < 7 || "number" == typeof Browser.Android && Browser.Android < 3 || Browser.MobileSafari && "number" == typeof Browser.WebKit && Browser.WebKit < 533.18) && (_Fresco.show = _Fresco.showFallback);
  var Thumbnails = {
    initialize: function initialize(element) {
      this.element = element;
      this._thumbnails = [];
      this._orientation = "vertical";
      this._vars = {
        thumbnail: {},
        thumbnailFrame: {},
        thumbnails: {}
      };
      this.build();
      this.startObserving();
    },
    build: function build() {
      console.log("Thumbnails:build");
      this.element.append(this.wrapper = $('<div class="fr-thumbnails-wrapper">').append(this._slider = $('<div class="fr-thumbnails-slider">').append(this._previous = $('<div class="fr-thumbnails-side fr-thumbnails-side-previous">').append(this._previous_button = $('<div class="fr-thumbnails-side-button">').append($('<div class="fr-thumbnails-side-button-background">')).append($('<div class="fr-thumbnails-side-button-icon">')))).append(this._thumbs = $('<div class="fr-thumbnails-thumbs">').append(this._slide = $('<div class="fr-thumbnails-slide">'))).append(this._next = $('<div class="fr-thumbnails-side fr-thumbnails-side-next">').append(this._next_button = $('<div class="fr-thumbnails-side-button">').append($('<div class="fr-thumbnails-side-button-background">')).append($('<div class="fr-thumbnails-side-button-icon">'))))));
    },
    startObserving: function startObserving() {
      this._slider.delegate(".fr-thumbnail", "click", function (event) {
        event.stopPropagation();
        var thumbnail = $(event.target).closest(".fr-thumbnail")[0];
        var position = thumbnail && $(thumbnail).data("fr-position");
        if (position) {
          this.setActive(position);
          Window.setPosition(position);
        }
      }.bind(this));

      // prevent bubbling on slider click, so you can safely click next to a thumbnail
      this._slider.bind("click", function (event) {
        event.stopPropagation();
      });

      // previous / next
      this._previous.bind("click", this.previousPage.bind(this));
      this._next.bind("click", this.nextPage.bind(this));
    },
    load: function load(views) {
      // first clear out any previous thumbnails
      this.clear();

      // set orientation
      // it's always horizontal unless 1 view has vertical
      var orientation = "horizontal";
      var disabled = false;
      $.each(views, function (i, view) {
        if (view.options.thumbnails === "vertical") {
          orientation = "vertical";
        }
        if (!view.options.thumbnails) disabled = true;
      }.bind(this));
      this.setOrientation(orientation);
      this._disabledGroup = disabled;
      $.each(views, function (i, view) {
        this._thumbnails.push(new Thumbnail(view, i + 1));
      }.bind(this));
      this.fitToViewport();
    },
    clear: function clear() {
      $.each(this._thumbnails, function (i, thumbnail) {
        thumbnail.remove();
      });
      this._thumbnails = [];
      this._position = -1;
      this._page = -1;
    },
    setOrientation: function setOrientation(orientation) {
      if (this._orientation) {
        Window.element.removeClass("fr-thumbnails-" + this._orientation);
      }
      Window.element.addClass("fr-thumbnails-" + orientation);
      this._orientation = orientation;
    },
    // disable / enable
    disable: function disable() {
      Window.element.removeClass("fr-thumbnails-enabled").addClass("fr-thumbnails-disabled");
      this._disabled = true;
    },
    enable: function enable() {
      Window.element.removeClass("fr-thumbnails-disabled").addClass("fr-thumbnails-enabled");
      this._disabled = false;
    },
    enabled: function enabled() {
      return !this._disabled;
    },
    disabled: function disabled() {
      return this._disabled;
    },
    // update current dimension variables
    updateVars: function updateVars() {
      var win = Window.element,
        vars = this._vars,
        orientation = this._orientation,
        isHorizontal = orientation === "horizontal",
        _top = isHorizontal ? "top" : "left",
        _left = isHorizontal ? "left" : "top",
        _mbottom = isHorizontal ? "bottom" : "left",
        _mtop = isHorizontal ? "top" : "right",
        _width = isHorizontal ? "width" : "height",
        _height = isHorizontal ? "height" : "width",
        _swapZ = {
          left: "right",
          right: "left",
          top: "bottom",
          bottom: "top"
        };
      this.element.removeClass("fr-thumbnails-measured");
      var w_vis = win.is(":visible");
      if (!w_vis) win.show();

      // we have to observe visibility without having the disabled class on the window
      if (this.disabled()) this.enable();

      // exit early if we're not showing thumbnails
      if (!this.element.is(":visible") || this._thumbnails.length < 2) {
        // this._disabledGroup
        this.disable();

        // store some variables so getDimensions at least has these
        $.extend(this._vars.thumbnails, {
          width: 0,
          height: 0
        });

        // show the window again
        if (!w_vis) win.hide();
        this.element.addClass("fr-thumbnails-measured");

        // exit early
        return;
      } else {
        // otherwise enable and continue filling variables
        this.enable();
      }
      var previous = this._previous,
        next = this._next,
        viewport = Bounds.viewport();

      // NOTE: All dimensions are stored as if the orientation is horizontal.
      // base the height of the thumbnail on the height of the element, minus padding
      var height = this.element["inner" + _.String.capitalize(_height)](),
        paddingTop = parseInt(this._thumbs.css("padding-" + _top)) || 0,
        thumbnailHeight = Math.max(height - paddingTop * 2, 0),
        paddingLeft = parseInt(this._thumbs.css("padding-" + _left)) || 0,
        marginTotal = (parseInt(this.element.css("margin-" + _mbottom)) || 0) + (parseInt(this.element.css("margin-" + _mtop)) || 0);
      $.extend(vars.thumbnails, {
        height: height + marginTotal,
        // we store as z just to make dimensioning later easier
        width: viewport[isHorizontal ? "width" : "height"],
        paddingTop: paddingTop
      });
      $.extend(vars.thumbnail, {
        height: thumbnailHeight,
        width: thumbnailHeight
      });
      $.extend(vars.thumbnailFrame, {
        width: thumbnailHeight + paddingLeft * 2,
        height: height
      });

      // previous/next
      vars.sides = {
        previous: {
          width: next["inner" + _.String.capitalize(_width)](),
          marginLeft: parseInt(previous.css("margin-" + _left)) || 0,
          // left
          marginRight: parseInt(previous.css("margin-" + _swapZ[_left])) || 0 // right
        },
        next: {
          width: next["inner" + _.String.capitalize(_width)](),
          marginLeft: parseInt(next.css("margin-" + _left)) || 0,
          // left
          marginRight: parseInt(next.css("margin-" + _swapZ[_left])) || 0 // right
        }
      };

      // how many pages and ipp
      // first try to fit all the thu
      var viewportWidth = viewport[_width],
        //$(window).width()
        thumbnailOuterWidth = vars.thumbnailFrame.width,
        thumbs = this._thumbnails.length;
      vars.thumbnails.width = viewportWidth;
      vars.sides.enabled = thumbs * thumbnailOuterWidth / viewportWidth > 1;

      // disable the sides if we have only 1 thumbnail
      var thumbsWidth = viewportWidth,
        vs = vars.sides,
        vsPrevious = vs.previous,
        vsNext = vs.next,
        sidesWidth = vsPrevious.marginLeft + vsPrevious.width + vsPrevious.marginRight + vsNext.marginLeft + vsNext.width + vsNext.marginRight;
      if (vars.sides.enabled) {
        thumbsWidth -= sidesWidth;
      }

      // lower the thumbnail width to a factor of a thumbnail
      thumbsWidth = Math.floor(thumbsWidth / thumbnailOuterWidth) * thumbnailOuterWidth;
      var totalThumbsWidth = thumbs * thumbnailOuterWidth;
      if (totalThumbsWidth < thumbsWidth) {
        thumbsWidth = totalThumbsWidth;
      }

      // now adust the wrapper to match that size
      var wrapperWidth = thumbsWidth + (vars.sides.enabled ? sidesWidth : 0);

      // items per page
      vars.ipp = Math.round(thumbsWidth / thumbnailOuterWidth); //Math.max(thumbsWidth / tw, 1); // at least one

      this._mode = "page";
      if (vars.ipp <= 1) {
        // recalculate width
        thumbsWidth = viewportWidth;
        wrapperWidth = viewportWidth;
        vars.sides.enabled = false;
        this._mode = "center";
      }

      // now find out the pages
      vars.pages = Math.ceil(thumbs * thumbnailOuterWidth / thumbsWidth);
      vars.wrapper = {
        width: wrapperWidth + 1,
        // IE fix
        height: height
      };
      vars.thumbs = {
        width: thumbsWidth,
        height: height
      };
      vars.slide = {
        width: thumbs * thumbnailOuterWidth + 1,
        // IE fix
        height: height
      };
      if (!w_vis) win.hide();
      this.element.addClass("fr-thumbnails-measured");
    },
    hide: function hide() {
      this.disable();
      this.thumbnails.hide();
      this._visible = false;
    },
    getDimensions: function getDimensions() {
      var isHorizontal = this._orientation === "horizontal";
      return {
        width: isHorizontal ? this._vars.thumbnails.width : this._vars.thumbnails.height,
        height: isHorizontal ? this._vars.thumbnails.height : this._vars.thumbnails.width
      };
    },
    // resize
    fitToViewport: function fitToViewport() {
      // make sure vars are set so we can use them
      this.updateVars();
      if (this.disabled()) return;
      var vars = $.extend({}, this._vars),
        isHorizontal = this._orientation === "horizontal";

      // individual thumbnails
      $.each(this._thumbnails, function (i, thumbnail) {
        thumbnail.resize();
      });

      // show hide sides
      this._previous[vars.sides.enabled ? "show" : "hide"]();
      this._next[vars.sides.enabled ? "show" : "hide"]();
      this._thumbs.css({
        width: vars.thumbs[isHorizontal ? "width" : "height"],
        height: vars.thumbs[isHorizontal ? "height" : "width"]
      });
      this._slide.css({
        width: vars.slide[isHorizontal ? "width" : "height"],
        height: vars.slide[isHorizontal ? "height" : "width"]
      });
      var wrapperCSS = {
        width: vars.wrapper[isHorizontal ? "width" : "height"],
        height: vars.wrapper[isHorizontal ? "height" : "width"]
      };
      wrapperCSS["margin-" + (isHorizontal ? "left" : "top")] = Math.round(-0.5 * vars.wrapper.width) + "px";
      wrapperCSS["margin-" + (!isHorizontal ? "left" : "top")] = 0;
      this.wrapper.css(wrapperCSS);

      // move to the correct position instantly
      if (this._position) {
        this.moveTo(this._position, true);
      }
    },
    moveToPage: function moveToPage(page) {
      if (page < 1 || page > this._vars.pages || page === this._page) return;
      var position = this._vars.ipp * (page - 1) + 1;
      this.moveTo(position);
    },
    previousPage: function previousPage() {
      this.moveToPage(this._page - 1);
    },
    nextPage: function nextPage() {
      this.moveToPage(this._page + 1);
    },
    show: function show(position) {
      // move instantly when the position wasn't set before
      var instant = this._position < 0;

      // make sure position is available
      if (position < 1) position = 1;
      var ic = this._thumbnails.length;
      if (position > ic) position = ic;

      // set it
      this._position = position;
      this.setActive(position);

      // don't move if we are using page mode and are on this page
      if (this._mode === "page" && this._page === Math.ceil(position / this._vars.ipp)) return;
      this.moveTo(position, instant);
    },
    moveTo: function moveTo(position, instant) {
      this.updateVars();
      if (this.disabled()) return;
      var left,
        isHorizontal = this._orientation === "horizontal",
        vp_z = Bounds.viewport()[isHorizontal ? "width" : "height"],
        vp_center = vp_z * 0.5,
        t_width = this._vars.thumbnailFrame.width,
        page;
      if (this._mode === "page") {
        page = Math.ceil(position / this._vars.ipp);

        // set the page
        this._page = page;
        left = -1 * (t_width * (this._page - 1) * this._vars.ipp);

        // disabled states on buttons
        var disabled = "fr-thumbnails-side-button-disabled";
        this._previous_button[(page < 2 ? "add" : "remove") + "Class"](disabled);
        this._next_button[(page >= this._vars.pages ? "add" : "remove") + "Class"](disabled);
      } else {
        // center
        left = vp_center + -1 * (t_width * (position - 1) + t_width * 0.5);
      }
      page = Pages.page;

      // now move there
      var resetCSS = {},
        animateCSS = {};
      resetCSS[!isHorizontal ? "left" : "top"] = 0; // zero out the other offset in case of switching orientation
      animateCSS[isHorizontal ? "left" : "top"] = left + "px";
      this._slide.stop(true).css(resetCSS).animate(animateCSS, instant ? 0 : page ? page.view.options.effects.thumbnails.slide || 0 : 0, function () {
        // load all thumbnails on this page
        this.loadCurrentPage();
      }.bind(this));
    },
    loadCurrentPage: function loadCurrentPage() {
      var min, max;

      // load protection, don't load when there's no position or width on the thumbnail
      if (!this._position || !this._vars.thumbnailFrame.width || this._thumbnails.length < 1) return;
      if (this._mode === "page") {
        // load the thumbnail on the current page
        if (this._page < 1) return;
        min = (this._page - 1) * this._vars.ipp + 1;
        max = Math.min(min - 1 + this._vars.ipp, this._thumbnails.length);
      } else {
        // mode is 'center', load the thumbnails within the viewport
        var thumbnail_count = Math.ceil(this._vars.thumbnails.width / this._vars.thumbnailFrame.width);
        min = Math.max(Math.floor(Math.max(this._position - thumbnail_count * 0.5, 0)), 1);
        max = Math.ceil(Math.min(this._position + thumbnail_count * 0.5));
        if (this._thumbnails.length < max) max = this._thumbnails.length;
      }

      // load the thumbnails
      for (var i = min; i <= max; i++) {
        this._thumbnails[i - 1].load();
      }
    },
    // only the active class
    setActive: function setActive(position) {
      this._slide.find(".fr-thumbnail-active").removeClass("fr-thumbnail-active");
      var thumbnail = position && this._thumbnails[position - 1];
      if (thumbnail) thumbnail.activate();
    },
    refresh: function refresh() {
      if (this._position) this.setPosition(this._position);
    }
  };
  // Thumbnail
  function Thumbnail() {
    this.initialize.apply(this, _slice.call(arguments));
  }
  $.extend(Thumbnail.prototype, {
    initialize: function initialize(view, position) {
      this.view = view;
      this._position = position;
      this.preBuild();
    },
    preBuild: function preBuild() {
      this.thumbnail = $('<div class="fr-thumbnail">').data("fr-position", this._position);
    },
    build: function build() {
      if (this.thumbnailFrame) return;
      var options = this.view.options;
      Thumbnails._slide.append(this.thumbnailFrame = $('<div class="fr-thumbnail-frame">').append(this.thumbnail.append(this.thumbnailWrapper = $('<div class="fr-thumbnail-wrapper">'))));
      if (this.view.type === "image") {
        this.thumbnail.addClass("fr-load-thumbnail").data("thumbnail", {
          view: this.view,
          src: options.thumbnail || this.view.url
        });
      }

      // icon
      var icon = options.thumbnail && options.thumbnail.icon;
      if (icon) {
        this.thumbnail.append($('<div class="fr-thumbnail-icon fr-thumbnail-icon-"' + icon + ">"));
      }

      // overlay
      var overlay;
      this.thumbnail.append(overlay = $('<div class="fr-thumbnail-overlay">').append($('<div class="fr-thumbnail-overlay-background">')).append(this.loading = $('<div class="fr-thumbnail-loading">').append($('<div class="fr-thumbnail-loading-background">')).append(this.spinner = $('<div class="fr-thumbnail-spinner">').hide().append($('<div class="fr-thumbnail-spinner-spin">')))).append($('<div class="fr-thumbnail-overlay-border">')));
      this.thumbnail.append($('<div class="fr-thumbnail-state">'));
      this.resize();
    },
    remove: function remove() {
      if (this.thumbnailFrame) {
        this.thumbnailFrame.remove();
        this.thumbnailFrame = null;
        this.image = null;
      }
      if (this.ready) {
        this.ready.abort();
        this.ready = null;
      }
      if (this.vimeoThumbnail) {
        this.vimeoThumbnail.abort();
        this.vimeoThumbnail = null;
      }
      this._loading = false;
      this._removed = true;

      // clean up
      this.view = null;
      this._clearDelay();
    },
    load: function load() {
      if (this._loaded || this._loading || this._removed) return;
      if (!this.thumbnailWrapper) this.build();
      this._loading = true;
      var thumbnail = this.view.options.thumbnail;
      var url = thumbnail && typeof thumbnail === "boolean" ? this.view.url : thumbnail || this.view.url;

      // store this now so we can modify it
      this._url = url;

      // vimeo needs an extra wrapper with a JSONP request
      if (url) {
        if (this.view.type === "vimeo") {
          if (url === thumbnail) {
            this._url = url;
            this._load(this._url);
          } else {
            switch (this.view.type) {
              case "vimeo":
                this.vimeoThumbnail = new VimeoThumbnail(this.view.url, function (url) {
                  this._url = url;
                  this._load(url);
                }.bind(this), function () {
                  this._error();
                }.bind(this));
                break;
            }
          }
        } else {
          // youtube
          this._load(this._url);
        }
      }
    },
    activate: function activate() {
      this.thumbnail.addClass("fr-thumbnail-active");
    },
    _load: function _load(url) {
      this.thumbnailWrapper.prepend(this.image = $('<img class="fr-thumbnail-image">').attr({
        src: url
      }).css({
        opacity: 0.0001
      }));
      this.fadeInSpinner();
      this.ready = new ImageReady(this.image[0], function (imageready) {
        var img = imageready.img;

        // if the thumbnail has been removed before we finish,
        // or if the _loading has been cancelled,
        // just quit
        if (!this.thumbnailFrame || !this._loading) return;
        this._loaded = true;
        this._loading = false;

        // store dimensions, used by resize
        this._dimensions = {
          width: img.naturalWidth,
          height: img.naturalHeight
        };

        // set dimensions after having loaded
        this.resize();

        // fadeout spinner
        this.show();
      }.bind(this), function () {
        this._error();
      }.bind(this), {
        method: this.view.options.loadedMethod
      });
    },
    // error callback
    _error: function _error() {
      this._loaded = true;
      this._loading = false;
      this.thumbnail.addClass("fr-thumbnail-error");
      if (this.image) {
        this.image.hide();
      }
      this.thumbnailWrapper.append($('<div class="fr-thumbnail-image">'));
      this.show();
    },
    fadeInSpinner: function fadeInSpinner() {
      if (!Spinner.supported || !this.view.options.spinner) return;

      // clear possible delay
      this._clearDelay();
      var fx = this.view.options.effects.thumbnail;
      this._delay = setTimeout(function () {
        this.spinner.stop(true).fadeTo(fx.show || 0, 1);
      }.bind(this), this.view.options.spinnerDelay || 0);
    },
    // fades out the loading block
    // which could also contain a spinner
    show: function show() {
      // clear possible delay
      this._clearDelay();
      var fx = this.view.options.effects.thumbnail;
      this.loading.stop(true).delay(fx.delay).fadeTo(fx.show, 0);
    },
    _clearDelay: function _clearDelay() {
      if (this._delay) {
        clearTimeout(this._delay);
        this._delay = null;
      }
    },
    // center image based on current dimensions
    resize: function resize() {
      if (!this.thumbnailFrame) return;
      var isHorizontal = Thumbnails._orientation === "horizontal";

      // frame
      this.thumbnailFrame.css({
        width: Thumbnails._vars.thumbnailFrame[isHorizontal ? "width" : "height"],
        height: Thumbnails._vars.thumbnailFrame[isHorizontal ? "height" : "width"]
      });

      // position frame
      this.thumbnailFrame.css({
        top: isHorizontal ? 0 : Thumbnails._vars.thumbnailFrame.width * (this._position - 1),
        left: isHorizontal ? Thumbnails._vars.thumbnailFrame.width * (this._position - 1) : 0
      });
      if (!this.thumbnailWrapper) return;

      // resize the wrapper
      var thumbnail = Thumbnails._vars.thumbnail;
      this.thumbnail.css({
        width: thumbnail.width,
        height: thumbnail.height,
        "margin-top": Math.round(-0.5 * thumbnail.height),
        "margin-left": Math.round(-0.5 * thumbnail.width),
        "margin-bottom": 0,
        "margin-right": 0
      });

      // if there's no image, don't resize the rest
      if (!this._dimensions) return;
      var bounds = {
        width: thumbnail.width,
        //this.thumbnail.innerWidth(),
        height: thumbnail.height //this.thumbnail.innerHeight()
      };
      var maxZ = Math.max(bounds.width, bounds.height);
      var dimensions;
      var image = $.extend({}, this._dimensions);
      if (image.width > bounds.width && image.height > bounds.height) {
        dimensions = Fit.within(bounds, image);

        // if the dimensions are smaller than bounds, increase them
        var scaleX = 1,
          scaleY = 1;
        if (dimensions.width < bounds.width) {
          scaleX = bounds.width / dimensions.width;
        }
        if (dimensions.height < bounds.height) {
          scaleY = bounds.height / dimensions.height;
        }
        var scale = Math.max(scaleX, scaleY);
        if (scale > 1) {
          dimensions.width *= scale;
          dimensions.height *= scale;
        }
        $.each("width height".split(" "), function (i, z) {
          dimensions[z] = Math.round(dimensions[z]); // .5 for anti-aliasing
        });
      } else {
        dimensions = Fit.within(this._dimensions, image.width < bounds.width || image.height < bounds.height ? {
          width: maxZ,
          height: maxZ
        } : bounds);
      }
      var x = Math.round(bounds.width * 0.5 - dimensions.width * 0.5),
        y = Math.round(bounds.height * 0.5 - dimensions.height * 0.5);
      this.image.removeAttr("style") // remove the opacity
      .css($.extend({}, dimensions, {
        top: y,
        left: x
      }));
    }
  });
  var UI = {
    _modes: ["fullclick", "outside", "inside"],
    _ui: !1,
    _validClickTargetSelector: [".fr-content-element", ".fr-content", ".fr-content > .fr-stroke", ".fr-content > .fr-stroke .fr-stroke-color"].join(", "),
    initialize: function initialize(i) {
      $.each(this._modes, function (i, e) {
        this[e].initialize();
      }.bind(this)), Window.element.addClass("fr-ui-inside-hidden fr-ui-fullclick-hidden");
    },
    set: function set(i) {
      this._ui && (Window.element.removeClass("fr-window-ui-" + this._ui), Overlay.element.removeClass("fr-overlay-ui-" + this._ui)), Window.element.addClass("fr-window-ui-" + i), Overlay.element.addClass("fr-overlay-ui-" + i), this._enabled && this._ui && this._ui !== i && (this[this._ui].disable(), this[i].enable(), UI[i].show()), this._ui = i;
    },
    _onWindowResize: function _onWindowResize() {
      Support.mobileTouch && this.show();
    },
    enable: function enable() {
      $.each(this._modes, function (i, e) {
        UI[e][e === this._ui ? "enable" : "disable"]();
      }.bind(this)), this._enabled = !0;
    },
    disable: function disable() {
      $.each(this._modes, function (i, e) {
        UI[e].disable();
      }.bind(this)), this._enabled = !1;
    },
    adjustPrevNext: function adjustPrevNext(i, e) {
      UI[this._ui].adjustPrevNext(i, e);
    },
    show: function show(i, e) {
      UI[this._ui].show(i, e);
    },
    hide: function hide(i, e) {
      UI[this._ui].hide(i, e);
    },
    reset: function reset() {
      $.each(this._modes, function (i, e) {
        UI[e].reset();
      }.bind(this));
    },
    update: function update() {
      var i = Pages.page;
      i && this.set(i._ui);
    },
    fullclick: {
      initialize: function initialize() {
        this.build(), this._scrollLeft = -1;
      },
      build: function build() {
        Window._box.append(this._previous = $("<div>").addClass("fr-side fr-side-previous fr-side-previous-fullclick fr-toggle-ui").append($("<div>").addClass("fr-side-button").append($("<div>").addClass("fr-side-button-background")).append($("<div>").addClass("fr-side-button-icon")))).append(this._next = $("<div>").addClass("fr-side fr-side-next fr-side-next-fullclick fr-toggle-ui").append($("<div>").addClass("fr-side-button").append($("<div>").addClass("fr-side-button-background")).append($("<div>").addClass("fr-side-button-icon")))).append(this._close = $("<div>").addClass("fr-close fr-close-fullclick").append($("<div>").addClass("fr-close-background")).append($("<div>").addClass("fr-close-icon"))), Browser.IE && Browser.IE <= 7 && this._previous.add(this._next).add(this._close).hide(), this._close.on("click", function (i) {
          i.preventDefault(), Window.hide();
        }.bind(this)), this._previous.on("click", function (i) {
          Window.previous(), this._onMouseMove(i);
        }.bind(this)), this._next.on("click", function (i) {
          Window.next(), this._onMouseMove(i);
        }.bind(this));
      },
      enable: function enable() {
        this.bind();
      },
      disable: function disable() {
        this.unbind();
      },
      reset: function reset() {
        Window.timers.clear("ui-fullclick"), this._x = -1, this._y = -1, this._scrollLeft = -1, this.resetPrevNext(), this._onMouseLeave();
      },
      resetPrevNext: function resetPrevNext() {
        this._previous.add(this._next).stop(!0).removeAttr("style");
      },
      bind: function bind() {
        this._onMouseUpHandler || (this.unbind(), Window._pages.on("mouseup", ".fr-container", this._onMouseUpHandler = this._onMouseUp.bind(this)), Support.mobileTouch || (Window.element.on("mouseenter", this._showHandler = this.show.bind(this)).on("mouseleave", this._hideHandler = this.hide.bind(this)), Window.element.on("mousemove", this._mousemoveHandler = function (i) {
          var e = i.pageX,
            i = i.pageY;
          this._hoveringSideButton || i === this._y && e === this._x || (this._x = e, this._y = i, this.show(), this.startTimer());
        }.bind(this)), Window._pages.on("mousemove", ".fr-container", this._onMouseMoveHandler = this._onMouseMove.bind(this)).on("mouseleave", ".fr-container", this._onMouseLeaveHandler = this._onMouseLeave.bind(this)).on("mouseenter", ".fr-container", this._onMouseEnterHandler = this._onMouseEnter.bind(this)), Window.element.on("mouseenter", ".fr-side", this._onSideMouseEnterHandler = this._onSideMouseEnter.bind(this)).on("mouseleave", ".fr-side", this._onSideMouseLeaveHandler = this._onSideMouseLeave.bind(this)), $(window).on("scroll", this._onScrollHandler = this._onScroll.bind(this))));
      },
      unbind: function unbind() {
        this._onMouseUpHandler && (Window._pages.off("mouseup", ".fr-container", this._onMouseUpHandler), this._onMouseUpHandler = null, this._showHandler && (Window.element.off("mouseenter", this._showHandler).off("mouseleave", this._hideHandler).off("mousemove", this._mousemoveHandler), Window._pages.off("mousemove", ".fr-container", this._onMouseMoveHandler).off("mouseleave", ".fr-container", this._onMouseLeaveHandler).off("mouseenter", ".fr-container", this._onMouseEnterHandler), Window.element.off("mouseenter", ".fr-side", this._onSideMouseEnterHandler).off("mouseleave", ".fr-side", this._onSideMouseLeaveHandler), $(window).off("scroll", this._onScrollHandler), this._showHandler = null));
      },
      adjustPrevNext: function adjustPrevNext(i, e) {
        var t,
          s,
          n,
          o = Pages.page;
        o && ((s = Window.element.is(":visible")) || Window.element.show(), n = this._previous.attr("style"), this._previous.removeAttr("style"), t = parseInt(this._previous.css("margin-top")), this._previous.attr({
          style: n
        }), s || Window.element.hide(), n = o._infoHeight || 0, s = this._previous.add(this._next), n = {
          "margin-top": t - 0.5 * n
        }, e = "number" == typeof e ? e : Pages.page && Pages.page.view.options.effects.content.show || 0, this.opening && (e = 0), s.stop(!0).animate(n, e, i), this._previous[(Window.mayPrevious() ? "remove" : "add") + "Class"]("fr-side-disabled"), this._next[(Window.mayNext() ? "remove" : "add") + "Class"]("fr-side-disabled"), s[(o._total < 2 ? "add" : "remove") + "Class"]("fr-side-hidden")), i && i();
      },
      _onScroll: function _onScroll() {
        this._scrollLeft = $(window).scrollLeft();
      },
      _onMouseMove: function _onMouseMove(i) {
        if (!Support.mobileTouch) {
          var e = this._getEventSide(i),
            i = _.String.capitalize(e),
            i = !!e && Window["may" + i]();
          if (e !== this._hoveringSide || i !== this._mayClickHoveringSide) switch (this._hoveringSide = e, this._mayClickHoveringSide = i, Window._box[(i ? "add" : "remove") + "Class"]("fr-hovering-clickable"), e) {
            case "previous":
              Window._box.addClass("fr-hovering-previous").removeClass("fr-hovering-next");
              break;
            case "next":
              Window._box.addClass("fr-hovering-next").removeClass("fr-hovering-previous");
          }
        }
      },
      _onMouseLeave: function _onMouseLeave(i) {
        Window._box.removeClass("fr-hovering-clickable fr-hovering-previous fr-hovering-next"), this._hoveringSide = !1;
      },
      _onMouseUp: function _onMouseUp(i) {
        var e;
        1 < i.which || (1 !== Pages.pages.length ? (e = this._getEventSide(i), Window[e](), this._onMouseMove(i)) : Window.hide());
      },
      _onMouseEnter: function _onMouseEnter(i) {
        this._onMouseMove(i);
      },
      _getEventSide: function _getEventSide(i) {
        -1 < this._scrollLeft ? this._scrollLeft : this._scrollLeft = $(window).scrollLeft();
        return i.pageX - Window._boxPosition.left - this._scrollLeft < 0.5 * Window._boxDimensions.width ? "previous" : "next";
      },
      _onSideMouseEnter: function _onSideMouseEnter(i) {
        this._hoveringSideButton = !0, this._hoveringSide = this._getEventSide(i), this._mayClickHoveringSide = Window["may" + _.String.capitalize(this._hoveringSide)](), this.clearTimer();
      },
      _onSideMouseLeave: function _onSideMouseLeave(i) {
        this._hoveringSideButton = !1, this._hoveringSide = !1, this._mayClickHoveringSide = !1, this.startTimer();
      },
      show: function show(i) {
        if (this._visible) return this.startTimer(), void ("function" == typeof i && i());
        this._visible = !0, this.startTimer(), Window.element.addClass("fr-visible-fullclick-ui").removeClass("fr-hidden-fullclick-ui"), Browser.IE && Browser.IE <= 7 && this._previous.add(this._next).add(this._close).show(), "function" == typeof i && i();
      },
      hide: function hide(i) {
        var e = Pages.page && Pages.page.view.type;
        this._visible && (!e || "youtube" !== e && "vimeo" !== e) ? (this._visible = !1, Window.element.removeClass("fr-visible-fullclick-ui").addClass("fr-hidden-fullclick-ui"), "function" === $.type(i) && i()) : "function" == typeof i && i();
      },
      clearTimer: function clearTimer() {
        Support.mobileTouch || Window.timers.clear("ui-fullclick");
      },
      startTimer: function startTimer() {
        Support.mobileTouch || (this.clearTimer(), Window.timers.set("ui-fullclick", function () {
          this.hide();
        }.bind(this), Window.view ? Window.view.options.uiDelay : 0));
      }
    },
    inside: {
      initialize: function initialize() {},
      enable: function enable() {
        this.bind();
      },
      disable: function disable() {
        this.unbind();
      },
      bind: function bind() {
        this._onMouseUpHandler || (this.unbind(), Window._pages.on("mouseup", ".fr-content", this._onMouseUpHandler = this._onMouseUp.bind(this)), Window._pages.on("click", ".fr-content .fr-close", function (i) {
          i.preventDefault(), Window.hide();
        }.bind(this)).on("click", ".fr-content .fr-side-previous", function (i) {
          Window.previous(), this._onMouseMove(i);
        }.bind(this)).on("click", ".fr-content .fr-side-next", function (i) {
          Window.next(), this._onMouseMove(i);
        }.bind(this)), Window.element.on("click", ".fr-container, .fr-thumbnails, .fr-thumbnails-wrapper", this._delegateOverlayCloseHandler = this._delegateOverlayClose.bind(this)), Support.mobileTouch || (Window.element.on("mouseenter", ".fr-content", this._showHandler = this.show.bind(this)).on("mouseleave", ".fr-content", this._hideHandler = this.hide.bind(this)), Window.element.on("mousemove", ".fr-content", this._mousemoveHandler = function (i) {
          var e = i.pageX,
            i = i.pageY;
          this._hoveringSideButton || i === this._y && e === this._x || (this._x = e, this._y = i, this.show(), this.startTimer());
        }.bind(this)), Window._pages.on("mousemove", ".fr-info, .fr-close", function (i) {
          i.stopPropagation(), this._onMouseLeave(i);
        }.bind(this)), Window._pages.on("mousemove", ".fr-info", function () {
          this.clearTimer();
        }.bind(this)), Window._pages.on("mousemove", ".fr-content", this._onMouseMoveHandler = this._onMouseMove.bind(this)).on("mouseleave", ".fr-content", this._onMouseLeaveHandler = this._onMouseLeave.bind(this)).on("mouseenter", ".fr-content", this._onMouseEnterHandler = this._onMouseEnter.bind(this)), Window.element.on("mouseenter", ".fr-side", this._onSideMouseEnterHandler = this._onSideMouseEnter.bind(this)).on("mouseleave", ".fr-side", this._onSideMouseLeaveHandler = this._onSideMouseLeave.bind(this)), $(window).on("scroll", this._onScrollHandler = this._onScroll.bind(this))));
      },
      unbind: function unbind() {
        this._onMouseUpHandler && (Window._pages.off("mouseup", ".fr-content", this._onMouseUpHandler), this._onMouseUpHandler = null, Window._pages.off("click", ".fr-content .fr-close").off("click", ".fr-content .fr-side-previous").off("click", ".fr-content .fr-side-next"), Window.element.off("click", ".fr-container, .fr-thumbnails, .fr-thumbnails-wrapper", this._delegateOverlayCloseHandler), this._showHandler && (Window.element.off("mouseenter", ".fr-content", this._showHandler).off("mouseleave", ".fr-content", this._hideHandler).off("mousemove", ".fr-content", this._mousemoveHandler), Window._pages.off("mousemove", ".fr-info, .fr-close"), Window._pages.off("mousemove", ".fr-info"), Window._pages.off("mousemove", ".fr-content-element", this._onMouseMoveHandler).off("mouseleave", ".fr-content", this._onMouseLeaveHandler).off("mouseenter", ".fr-content", this._onMouseEnterHandler), Window.element.off("mouseenter", ".fr-side", this._onSideMouseEnterHandler).off("mouseleave", ".fr-side", this._onSideMouseLeaveHandler), $(window).off("scroll", this._onScrollHandler), this._showHandler = null));
      },
      reset: function reset() {
        Window.timers.clear("ui-fullclick"), this._x = -1, this._y = -1, this._scrollLeft = -1, this._hoveringSide = !1, this._onMouseLeave();
      },
      adjustPrevNext: function adjustPrevNext(i) {
        i && i();
      },
      _onScroll: function _onScroll() {
        this._scrollLeft = $(window).scrollLeft();
      },
      _delegateOverlayClose: function _delegateOverlayClose(i) {
        var e = Pages.page;
        e && e.view.options.overlay && !e.view.options.overlay.close || $(i.target).is(".fr-container, .fr-thumbnails, .fr-thumbnails-wrapper") && (i.preventDefault(), i.stopPropagation(), Window.hide());
      },
      _onMouseMove: function _onMouseMove(i) {
        if (!Support.mobileTouch) {
          var e = this._getEventSide(i),
            i = _.String.capitalize(e),
            i = !!e && Window["may" + i]();
          if ((e = 1 === Pages.pages.length || Pages.page && "close" === Pages.page.view.options.onClick ? !1 : e) !== this._hoveringSide || i !== this._mayClickHoveringSide) if (this._hoveringSide = e, this._mayClickHoveringSide = i, e) switch (Window._box[(i ? "add" : "remove") + "Class"]("fr-hovering-clickable"), e) {
            case "previous":
              Window._box.addClass("fr-hovering-previous").removeClass("fr-hovering-next");
              break;
            case "next":
              Window._box.addClass("fr-hovering-next").removeClass("fr-hovering-previous");
          } else Window._box.removeClass("fr-hovering-clickable fr-hovering-previous fr-hovering-next");
        }
      },
      _onMouseLeave: function _onMouseLeave(i) {
        Window._box.removeClass("fr-hovering-clickable fr-hovering-previous fr-hovering-next"), this._hoveringSide = !1;
      },
      _onMouseUp: function _onMouseUp(i) {
        var e;
        1 < i.which || !$(i.target).is(UI._validClickTargetSelector) || (1 === Pages.pages.length || Pages.page && "close" === Pages.page.view.options.onClick ? Window.hide() : (e = this._getEventSide(i), Window[e](), this._onMouseMove(i)));
      },
      _onMouseEnter: function _onMouseEnter(i) {
        this._onMouseMove(i);
      },
      _getEventSide: function _getEventSide(i) {
        -1 < this._scrollLeft ? this._scrollLeft : this._scrollLeft = $(window).scrollLeft();
        return i.pageX - Window._boxPosition.left - this._scrollLeft < 0.5 * Window._boxDimensions.width ? "previous" : "next";
      },
      _onSideMouseEnter: function _onSideMouseEnter(i) {
        this._hoveringSideButton = !0, this._hoveringSide = this._getEventSide(i), this._mayClickHoveringSide = Window["may" + _.String.capitalize(this._hoveringSide)](), this.clearTimer();
      },
      _onSideMouseLeave: function _onSideMouseLeave(i) {
        this._hoveringSideButton = !1, this._hoveringSide = !1, this._mayClickHoveringSide = !1, this.startTimer();
      },
      show: function show(i) {
        if (this._visible) return this.startTimer(), void ("function" == typeof i && i());
        this._visible = !0, this.startTimer(), Window.element.addClass("fr-visible-inside-ui").removeClass("fr-hidden-inside-ui"), "function" == typeof i && i();
      },
      hide: function hide(i) {
        this._visible && (this._visible = !1, Window.element.removeClass("fr-visible-inside-ui").addClass("fr-hidden-inside-ui")), "function" == typeof i && i();
      },
      clearTimer: function clearTimer() {
        Support.mobileTouch || Window.timers.clear("ui-inside");
      },
      startTimer: function startTimer() {
        Support.mobileTouch || (this.clearTimer(), Window.timers.set("ui-inside", function () {
          this.hide();
        }.bind(this), Window.view ? Window.view.options.uiDelay : 0));
      }
    },
    outside: {
      initialize: function initialize() {
        this.build(), this._scrollLeft = -1;
      },
      build: function build() {
        Window._box.append(this._previous = $("<div>").addClass("fr-side fr-side-previous fr-side-previous-outside").append($("<div>").addClass("fr-side-button").append($("<div>").addClass("fr-side-button-background")).append($("<div>").addClass("fr-side-button-icon")))).append(this._next = $("<div>").addClass("fr-side fr-side-next fr-side-next-outside").append($("<div>").addClass("fr-side-button").append($("<div>").addClass("fr-side-button-background")).append($("<div>").addClass("fr-side-button-icon")))).append(this._close = $("<div>").addClass("fr-close fr-close-outside").append($("<div>").addClass("fr-close-background")).append($("<div>").addClass("fr-close-icon"))), Browser.IE && Browser.IE <= 7 && this._previous.add(this._next).add(this._close).hide(), this._close.on("click", function (i) {
          i.preventDefault(), Window.hide();
        }.bind(this)), this._previous.on("click", function (i) {
          Window.previous(), this._onMouseMove(i);
        }.bind(this)), this._next.on("click", function (i) {
          Window.next(), this._onMouseMove(i);
        }.bind(this));
      },
      enable: function enable() {
        this.bind();
      },
      disable: function disable() {
        this.unbind();
      },
      reset: function reset() {
        Window.timers.clear("ui-outside"), this._x = -1, this._y = -1, this._scrollLeft = -1, this._onMouseLeave();
      },
      bind: function bind() {
        this._onMouseUpHandler || (this.unbind(), Window.element.on("mouseup", ".fr-content", this._onMouseUpHandler = this._onMouseUp.bind(this)), Window.element.on("click", ".fr-container, .fr-thumbnails, .fr-thumbnails-wrapper", this._delegateOverlayCloseHandler = this._delegateOverlayClose.bind(this)), Support.mobileTouch || (Window._pages.on("mousemove", ".fr-content", this._onMouseMoveHandler = this._onMouseMove.bind(this)).on("mouseleave", ".fr-content", this._onMouseLeaveHandler = this._onMouseLeave.bind(this)).on("mouseenter", ".fr-content", this._onMouseEnterHandler = this._onMouseEnter.bind(this)), Window.element.on("mouseenter", ".fr-side", this._onSideMouseEnterHandler = this._onSideMouseEnter.bind(this)).on("mouseleave", ".fr-side", this._onSideMouseLeaveHandler = this._onSideMouseLeave.bind(this)), $(window).on("scroll", this._onScrollHandler = this._onScroll.bind(this))));
      },
      unbind: function unbind() {
        this._onMouseUpHandler && (Window.element.off("mouseup", ".fr-content", this._onMouseUpHandler), this._onMouseUpHandler = null, Window.element.off("click", ".fr-container, .fr-thumbnails, .fr-thumbnails-wrapper", this._delegateOverlayCloseHandler), this._onMouseMoveHandler && (Window._pages.off("mousemove", ".fr-content", this._onMouseMoveHandler).off("mouseleave", ".fr-content", this._onMouseLeaveHandler).off("mouseenter", ".fr-content", this._onMouseEnterHandler), Window.element.off("mouseenter", ".fr-side", this._onSideMouseEnterHandler).off("mouseleave", ".fr-side", this._onSideMouseLeaveHandler), $(window).off("scroll", this._onScrollHandler), this._onMouseMoveHandler = null));
      },
      adjustPrevNext: function adjustPrevNext(i, e) {
        var t,
          s = Pages.page;
        s && (t = this._previous.add(this._next), this._previous[(Window.mayPrevious() ? "remove" : "add") + "Class"]("fr-side-disabled"), this._next[(Window.mayNext() ? "remove" : "add") + "Class"]("fr-side-disabled"), t[(s._total < 2 ? "add" : "remove") + "Class"]("fr-side-hidden")), i && i();
      },
      _onScroll: function _onScroll() {
        this._scrollLeft = $(window).scrollLeft();
      },
      _delegateOverlayClose: function _delegateOverlayClose(i) {
        var e = Pages.page;
        e && e.view.options.overlay && !e.view.options.overlay.close || $(i.target).is(".fr-container, .fr-thumbnails, .fr-thumbnails-wrapper") && (i.preventDefault(), i.stopPropagation(), Window.hide());
      },
      _onMouseMove: function _onMouseMove(i) {
        if (!Support.mobileTouch) {
          var e = this._getEventSide(i),
            i = _.String.capitalize(e),
            i = !!e && Window["may" + i]();
          if ((e = 1 === Pages.pages.length || Pages.page && "close" === Pages.page.view.options.onClick ? !1 : e) !== this._hoveringSide || i !== this._mayClickHoveringSide) if (this._hoveringSide = e, this._mayClickHoveringSide = i, e) switch (Window._box[(i ? "add" : "remove") + "Class"]("fr-hovering-clickable"), e) {
            case "previous":
              Window._box.addClass("fr-hovering-previous").removeClass("fr-hovering-next");
              break;
            case "next":
              Window._box.addClass("fr-hovering-next").removeClass("fr-hovering-previous");
          } else Window._box.removeClass("fr-hovering-clickable fr-hovering-previous fr-hovering-next");
        }
      },
      _onMouseLeave: function _onMouseLeave(i) {
        Window._box.removeClass("fr-hovering-clickable fr-hovering-previous fr-hovering-next"), this._hoveringSide = !1;
      },
      _onMouseUp: function _onMouseUp(i) {
        var e;
        1 < i.which || !$(i.target).is(UI._validClickTargetSelector) || (1 === Pages.pages.length || Pages.page && "close" === Pages.page.view.options.onClick ? Window.hide() : (e = this._getEventSide(i), Window[e](), this._onMouseMove(i)));
      },
      _onMouseEnter: function _onMouseEnter(i) {
        this._onMouseMove(i);
      },
      _getEventSide: function _getEventSide(i) {
        -1 < this._scrollLeft ? this._scrollLeft : this._scrollLeft = $(window).scrollLeft();
        return i.pageX - Window._boxPosition.left - this._scrollLeft < 0.5 * Window._boxDimensions.width ? "previous" : "next";
      },
      show: function show() {
        Browser.IE && Browser.IE <= 7 && this._previous.add(this._next).add(this._close).show();
      },
      hide: function hide() {},
      _onSideMouseEnter: function _onSideMouseEnter(i) {
        this._hoveringSideButton = !0, this._hoveringSide = this._getEventSide(i), this._mayClickHoveringSide = Window["may" + _.String.capitalize(this._hoveringSide)]();
      },
      _onSideMouseLeave: function _onSideMouseLeave(i) {
        this._hoveringSideButton = !1, this._hoveringSide = !1, this._mayClickHoveringSide = !1;
      },
      clearTimer: function clearTimer() {}
    }
  };
  return $(function () {
    _Fresco.initialize();
  }), Fresco;
});